{
  "ageGate": {
    "back": "Back",
    "country": "Confirm your location to continue",
    "day": "Day",
    "description": "Already an existing customer? {0}",
    "dob": "Date of Birth",
    "enter": "Enter",
    "intro": "Welcome to LeafLink!",
    "leave": "Leave",
    "month": "Month",
    "notOfAge": "We're sorry, but you're not old enough to access this page.",
    "overAge": "Are you over 21 years of age?",
    "privacyPolicy": "Privacy Policy",
    "province": "Province",
    "termsOfUse": "Terms of Use",
    "title": "Age Verification",
    "usageAgreement": "By entering this site you agree to our {0} and {1}.",
    "year": "Year"
  },
  "brand_menu": {
    "addToCart": "Add to cart",
    "addToCartAcrossLocations": "Add to cart across available locations",
    "addToCartError": "There were some issues adding your items to the cart! <br /> Please check below for errors.",
    "addToCartErrorCount": "0 items with errors | {count} item with errors | {count} items with errors",
    "addToCartSuccessCount": "0 items added successfully | {count} item added successfully | {count} items added successfully",
    "amountOffPerCase": "{amount} off per case",
    "amountOffPerUnit": "{amount} off per unit",
    "batchesResults": "Batches and test results",
    "brandBanner": "Brand Banner",
    "brandLogo": "Brand Logo",
    "currentSubtotal": "Current cart Subtotal",
    "discountText": "when you spend ${thresholdAmount}",
    "errorFetchPublicPromos": "Unable to fetch public promos.",
    "errorFetchVolumeDiscounts": "Unable to fetch volume discounts.",
    "exportMenu": "Export Menu",
    "learnMore": "Want to learn more about {company}'s products?",
    "letThemKnow": "Let them know",
    "messageBrand": "Message {brand}",
    "messageSucess": "Message Sent",
    "moreFromSeller": "More from this Seller",
    "newSubtotal": "New cart Subtotal",
    "nextProduct": "Next product",
    "previousProduct": "Previous product",
    "printMenu": "Print Menu",
    "productDescription": "Product description",
    "productDetails": "Product details",
    "productInformation": "Product information",
    "promoCode": "Promo Code",
    "promotion": "Promotion",
    "quantityRequiredForAtLeastOneLocation": "A quantity must be specified for at least one location.",
    "selectedSubtotal": "Selected Subtotal",
    "takeMeBack": "Take me back to the old experience",
    "viewProductDetail": "View product detail page",
    "volumeDiscount": "Volume Discount",
    "volumeDiscounts": "Volume discounts"
  },
  "brands": {
    "previewMenu": {
      "description": "Edit product order and preview your menu",
      "generalInformation": {
        "descriptionFirstParagraph": "Below is a preview of how your menu appears to retailers when they shop {brand}. You can use the license type dropdown below to simulate a buyer who is shopping your products.",
        "descriptionSecondParagraph": "The areas highlighted in red are recommendations for improving your menu. These best practices are based on feedback we have received from retailers, so updating these can help make your menu more appealing to shoppers. These recommendations are only visible to you, the menu owner, and will not appear to retailers.",
        "descriptionThirdParagraph": "If you'd like additional recommendations for how to improve your menu, our Client Experience team is happy to help! Email them at support{'@'}leaflink.com.",
        "label": "Simulate shopper type",
        "title": "General Information"
      },
      "menuChecklist": {
        "descriptionFirstLine": "Do you see all the products you expect to see?",
        "descriptionFourthLine": "Are your sample requests and minimum/maximum order quantities set correctly?",
        "descriptionSecondLine": "Do all of your products have images and descriptions?",
        "descriptionThirdLine": "Are your products grouped by product line? (Recommended for long menus with many SKUs)",
        "title": "Menu Checklist"
      },
      "missing": {
        "addProducts": "Add Products",
        "companyNotLive": "Your menu is not visible to buyers on LeafLink yet. Reach out to your Onboarding Lead and they can help make your account public!",
        "featureProduct": {
          "header": "Missing Featured Product",
          "paragraph": "The featured product will appear here. The featured product allows you to highlight a single product for any reason you feel necessary. Whether it's new, on sale, or an old favorite, the featured product provides a valuable platform for the product itself. To set a featured product, mark it as “Featured” in Edit Product."
        },
        "headerImage": {
          "header": "Missing Brand Banner Image",
          "paragraph": "The brand banner image helps paint a picture of your brand's visual identity."
        },
        "products": {
          "header": "Missing Products",
          "paragraph": "You currently do not have any available products. Your products will appear here once added and set to available on the Inventory page."
        }
      },
      "selectLicense": "Select License",
      "title": "Preview Menu"
    }
  },
  "buyerDashboardOMS": {
    "header": {
      "greeting": "Welcome back, {name}!"
    },
    "orders": {
      "actions": {
        "cancel": "Cancel",
        "markReceived": "Mark Received",
        "message": "Message",
        "reorder": "Reorder",
        "viewAndAccept": "View & Accept"
      },
      "dateLabel": {
        "accepted": "Payment Due Date",
        "backorder": "Backordered Date",
        "cancelled": "Cancelled Date",
        "fulfilled": "Ship Date",
        "rejected": "Rejection Reason",
        "shipped": "Est. Delivery Date",
        "submitted": "Submitted Date"
      },
      "descriptions": {
        "newOrders": "Orders pending approval and recently approved orders",
        "onTheWay": "Reorder or confirm receipt of fulfilled or shipped orders",
        "unavailableOrders": "Reconnect with sellers on disrupted orders"
      },
      "emptyState": {
        "title": "You are all caught up.",
        "subtitle": "There are no new orders at the moment"
      },
      "overallMonthToDate": "Overall Month to Date",
      "purchasingSummary": "Purchasing Summary",
      "rejectionReasonLabel": {
        "ACCOUNT_ISSUE": "Account issue",
        "DELIVERY_ISSUE": "Delivery issue",
        "ORDER_ISSUE": "Order issue",
        "PAYMENT_ISSUE": "Payment issue",
        "PRODUCT_ISSUE": "Product issue",
        "OTHER": "Other"
      },
      "srFiltersLabel": "View a subset of orders",
      "srOrderCountLabel": "{count} this month",
      "viewAllPurchasingInsights": "View All Purchasing Insights"
    },
    "productSpotlight": {
      "header": "Product Spotlight",
      "description": "New brands, deals and products recommended for you",
      "emptyState": {
        "title": "Currently there aren't any featured products.<br>Start shopping to see your recommendations here!",
        "shopByMenu": {
          "brand": "@:common.brand",
          "product": "@:common.product",
          "discoverNewProducts": "Discover New Products",
          "yourFavorites": "Your Favorites",
          "purchaseHistory": "Purchase History"
        }
      }
    }
  },
  "buyerJoinTodayDirect": {
    "bullet1": {
      "description": "Earn 0.25% cash back on every purchase when you pay with LeafLink Direct Pay",
      "header": "0.25% cash back"
    },
    "bullet2": {
      "description": "Easily keep track of all your orders and payments right in LeafLink with a handy payment calendar",
      "header": "Never miss a payment"
    },
    "bullet3": {
      "description": "LeafLink ACH payments are completely free for retailers to send",
      "header": "$0 transaction fees"
    },
    "bullet4": {
      "description": "Know where your money is at all times, and eliminate the risk of theft or fraud",
      "header": "Secure, trackable payments"
    },
    "bullet5": {
      "description": "Stop wasting hours managing payments and orders in multiple systems",
      "header": "Automate and centralize accounts payable"
    },
    "ctaButton": "Get started!",
    "pageHeader": "Seamless, secure payments",
    "pageHeaderWithCashback": "Save money and earn cash back on your LeafLink orders",
    "pageSubheader": "Paying your bills shouldn’t cost you more money. Stop sending costly checks, cash deliveries and bank transfers, and switch to a secure, digital payment that doesn’t cost you a dime. LeafLink’s Direct Pay ACH payments are completely free to send.",
    "pageSubheaderWithCashback": "Paying your bills shouldn’t cost you more money. Stop sending costly checks, cash deliveries and bank transfers, and switch to a secure, digital payment that doesn’t cost you a dime. LeafLink’s Direct Pay ACH payments are completely free to send, AND you’ll earn 0.25% cash back on every dollar you spend.",
    "signUpHeader": "What you'll need to sign up",
    "signUpRequirements": {
      "first": "Your company’s banking credentials (account and routing numbers) to link an account",
      "second": "Up-to-date license information",
      "third": "Your TIN/EIN, which will help verify your business"
    }
  },
  "categoryManagement": {
    "cta": {
      "action": "Get on the waitlist",
      "ctaText": {
        "description": "Say goodbye to having 20 spreadsheets open at a time. Our algorithms can do the category management analysis for you, and provide a path to bigger margins.",
        "invitation": "Want early access to this feature?",
        "waitlist": "Stay tuned to your inbox. We're going to reach out to activate this feature for you very soon."
      },
      "title": "Coming Soon! Inventory Insights ⚡",
      "waitlistSubtitle": "You're on the waitlist!",
      "waitlistTitle": "Inventory Insights ⚡"
    },
    "interest": {
      "action": "Join waitlist now",
      "completedAction": "Thanks",
      "confirmation": "It's official! You're on the list of customers who will get early access to our new Inventory Insights. Stay tuned for more details.",
      "insights": "We're excited to hear you're interested in our new Inventory Insights!",
      "instruction": "To tailor your experience, tell us which POS you use in the store.",
      "posSelected": "POS Selected",
      "posSelectionLabel": "Select your POS",
      "title": "The Waitlist",
      "validationMsg": "Select one of the POS options. If you POS software is not listed you may select \"Other\"."
    },
    "selfService": {
      "action": "Explore Membership Plans",
      "badge": "LeafLink Plus",
      "body": "De-risk inventory investments and save time on data maintenance with advanced retail technology. We can recommend a daily action to help you maximize your margins.",
      "header": "New! LeafLink Plus Membership"
    }
  },
  "common": {
    "about": "About",
    "accept": "Accept",
    "acceptInvite": "Accept Invite",
    "accepted": "Accepted",
    "acceptedDate": "Accepted Date",
    "action": "Action",
    "actions": "Actions",
    "activate": "Activate",
    "activated": "Activated",
    "active": "Active",
    "add": "Add",
    "addBrand": "Add Brand",
    "addProducts": "Add Products",
    "added": "Added",
    "address": "Address",
    "adjust": "Adjust",
    "admin": "Admin",
    "ads": "Ads",
    "agreeToTerms": "Please agree to the terms of service",
    "aka": "AKA",
    "all": "All",
    "allLicenses": "All Licenses",
    "allProducts": "All products",
    "amount": "Amount",
    "amount_paid": "Amount Paid",
    "announcements": "Announcements",
    "any": "Any",
    "applies_to": "Applies to",
    "apply": "Apply",
    "apply_filters": "Apply Filters",
    "approve": "Approve",
    "approveOrder": "Approve Order",
    "approved": "Approved",
    "archive": "Archive",
    "archived": "Archived",
    "ascending": "Ascending",
    "assign": "Assign",
    "assignee": "Assignee",
    "asyncExportSuccess": "Your export is being processed and will be emailed to {email} when complete.",
    "attach": "Attach",
    "attempts": "Attempts",
    "autopay": "Autopay",
    "availability": "Availability",
    "available": "Available",
    "back": "Back",
    "backordered": "Backordered",
    "balance": "Balance",
    "bankAccount": "Bank Account",
    "barcode": "Barcode",
    "barcodes": "Barcodes",
    "batch": "Batch",
    "billTo": "Bill to",
    "billing": "Billing",
    "both": "Both",
    "boxCount": "0 Box | 1 Box | {num} Boxes",
    "brand": "Brand",
    "brands": "Brands",
    "bulk_actions": "Bulk Actions",
    "businessIdentifier": "Business Identifier",
    "buyer": "Buyer",
    "buyerName": "Buyer Name",
    "buyItAgain": "Buy It Again",
    "calendar": "Calendar",
    "cancel": "Cancel",
    "cannabinoidUnit": "Cannabinoid Unit",
    "cannabinoids": "Cannabinoids",
    "cannotFindUser": "Can't find a user? Manually enter email address here",
    "case": "Case",
    "cases": "Cases",
    "cash": "Cash",
    "category": "Category",
    "cbc": "CBC",
    "cbd": "CBD",
    "cbda": "CBDa",
    "cbg": "CBG",
    "cbga": "CBGa",
    "cbn": "CBN",
    "check_number": "Check number",
    "city": "City",
    "classification": "Classification",
    "clear": "Clear",
    "clear_filters": "Clear Filters",
    "clear_selection": "Clear selection",
    "clickToUpdate": "Click here to update",
    "cloneOrder": "Clone Order",
    "close": "Close",
    "closed": "Closed",
    "coa": "COA",
    "code": "Code",
    "color": "Color",
    "columns": "Columns",
    "comingSoon": "Coming Soon!",
    "comments": "Comments",
    "company": "Company",
    "companyInformation": "Company Information",
    "companyName": "Company Name",
    "completed": "Completed",
    "completedOn": "Completed on",
    "confirm": "Confirm",
    "confirmExit": "Confirm exit",
    "confirmExitText": "If you leave now, any change made will not be saved",
    "congratulations": "Congratulations",
    "contact": "Contact",
    "contactSupport": "Contact support",
    "contacts": "Contacts",
    "continue": "Continue",
    "copyLink": "Copy Link",
    "corporateAddress": "Corporate Address",
    "corporateBillingAddress": "Corporate Billing Address",
    "cost": "Cost",
    "costAndQuantity": "Cost & Quantity",
    "county": "County",
    "create": "Create",
    "createOrder": "Create Order",
    "createOrderLegacy": "Create Order (legacy)",
    "created": "Created",
    "createdBy": "Created by",
    "created_by": "Created By",
    "created_date": "Created Date",
    "created_on": "Created On",
    "creating": "Creating",
    "csvTemplate": "CSV Template",
    "currentlyUnavailable": "Currently Unavailable",
    "custom": "Custom",
    "customMenu": "Custom Menu",
    "customer": "Customer",
    "customerCount": "0 Customers | {count} Customer | {count} Customers",
    "customerInformation": "Customer Information",
    "customerWarehouse": "Customer Warehouse",
    "customers": "Customers",
    "date": "Date",
    "dateRange": "Date Range",
    "days": "Days",
    "daysPastDue": "{num} days past due",
    "deactivated": "Deactivated",
    "default": "Default",
    "delete": "Delete",
    "deleteImage": "Delete Image",
    "deliverTo": "Deliver to",
    "delivery": "Delivery",
    "deliveryAddress": "Delivery Address",
    "deliveryDate": "Delivery Date",
    "deliveryDateFrom": "Delivery Date From",
    "deliveryDestination": "Delivery Destination",
    "deliveryPreferences": "Delivery Preferences",
    "deliveryPreferencesDescription": "Enter any delivery preferences or directions you may have.",
    "deliveryPreferencesDirections": "Delivery Preferences/Directions",
    "denied": "Denied",
    "deniedRequests": "Denied Requests",
    "descending": "Descending",
    "description": "Description",
    "deselectAll": "Deselect all",
    "deselectAllCount": "Deselect all ({count})",
    "destination": "Destination",
    "destinationLicense": "Destination License",
    "details": "Details",
    "dialogs": {
      "confirm_removal": "Are you sure you would like to remove this?"
    },
    "directPay": "Direct Pay",
    "disclaimer": "LeafLink Logistics, Inc. provides technology to simplify fulfillment and distribution between legal cannabis license holders and does not participate in, or control, any commercial cannabis activities.",
    "discount": "Discount",
    "discountAmountOff": "{amount} off",
    "discount_type": "Discount Type",
    "discounts": "Discounts",
    "dismiss": "Dismiss",
    "disputed": "Disputed",
    "dollarAmount": "Dollar Amount",
    "done": "Done",
    "dontShowMessageAgain": "Don't show this message again",
    "download": "Download",
    "downloadTemplate": "Download Template",
    "download_all_orders": "Download All Orders",
    "driver": "Driver",
    "due": "Due",
    "dueDate": "Due Date",
    "duplicate": "Duplicate",
    "edit": "Edit",
    "editBrand": "Edit Brand",
    "editOrder": "Edit Order",
    "editOrderLegacy": "Edit Order (legacy)",
    "editPaymentMethod": "Edit Payment Method",
    "edit_contact": "Edit Contact",
    "edit_customer": "Edit Customer",
    "edit_customers": "Edit Customers",
    "edit_prices": "Edit Prices",
    "edited": "Edited",
    "editing": "Editing",
    "either": "Either",
    "eligibleToShipToFulfillmentCenter": "Eligible to ship to Fulfillment Center",
    "email": "Email",
    "empty": "empty",
    "emptyPlaceholder": "---",
    "end_date": "End Date",
    "enroll": "Enroll",
    "errors": "Errors",
    "example": "Example",
    "exciseTax": "Excise Tax",
    "exit": "Exit",
    "expiration": "Expiration",
    "expirationDate": "Expiration Date",
    "expired": "Expired",
    "expires": "Expires",
    "export": "Export",
    "ext": "ext",
    "externalId": "External ID",
    "facebook": "Facebook",
    "facilities": "Facilities",
    "facility": "Facility",
    "false": "False",
    "faq": "FAQ",
    "featured": "Featured",
    "fields": "Fields",
    "file": "File",
    "filter": "Filter",
    "filters": "Filters",
    "first_name": "First Name",
    "flexPay": "Flex Pay",
    "formula": "Formula",
    "free": "Free",
    "from": "From",
    "fulfilledWithLeafLink": "Fulfilled with LeafLink",
    "fulfillment_queue": "Fulfillment Queue",
    "groupCount": "0 Groups | {count} Group | {count} Groups",
    "groups": "Groups",
    "groupsAndCustomers": "Groups & Customers",
    "growOperation": "Grow Operation",
    "hide": "Hide",
    "id": "ID",
    "ids": "IDs",
    "image": "Image",
    "imageCount": "Image {index} of {total}",
    "import": "Import",
    "importInvoice": "Import Invoice",
    "importing": "Importing",
    "inProgress": "In Progress",
    "inactive": "Inactive",
    "instagram": "Instagram",
    "internalApprovals": "Internal Approvals",
    "inventory": "Inventory",
    "inventoryTotals": "Inventory Totals",
    "invoiceId": "Invoice ID",
    "invoicePdf": "Invoice PDF",
    "invoiceTotal": "Invoice Total",
    "invoiceType": "Invoice Type",
    "invoices": "Invoices",
    "isProcessed": "Processed",
    "isRequired": "{field} is required",
    "is_mapped": "Is Mapped",
    "issueDate": "Issue Date",
    "issued": "Issued",
    "item": "Item",
    "items": "Items",
    "itemsCount": "0 Items | {count} Item | {count} Items",
    "joinToday": "Join today!",
    "key": "Key",
    "label": "Label",
    "last_modified": "Last Modified",
    "last_name": "Last Name",
    "last_ordered": "Last Ordered",
    "leafLinkPlan": "LeafLink Plan",
    "learnMore": "Learn More",
    "leavePage": "Leave Page",
    "license": "License",
    "licenseNumber": "License Number",
    "licenseOrLicenses": "License(s)",
    "licenseRequestChange": "Are you sure you want to submit a 'License Change Request' without transferring products?\nTo transfer products from an existing license, select a license in the 'Transfer Products From' drop-down.\nIf you are adding a new license number, ignore this message.",
    "licenseType": "License Type",
    "licenses": "Licenses",
    "listingState": "Listing State",
    "llPayments": "LeafLink Payments",
    "load_more": "Load More",
    "loading": "Loading",
    "location": "Location",
    "locations": "Locations",
    "logIn": "Log In",
    "logistics": "Logistics",
    "logo": "logo",
    "make_payment": "Make Payment",
    "make_primary_contact": "Make Primary Contact",
    "mapping": "Mapping",
    "max": "Max",
    "maximum": "Maximum",
    "menu": "Menu",
    "message": "Message",
    "messages": "Messages",
    "methods": "Methods",
    "min": "Min",
    "minimum": "Minimum",
    "modal": {
      "action": "Action",
      "itemSelected": "{number} of {total} selected",
      "selectAllItems": "Select all"
    },
    "modified": "Modified",
    "more": "More",
    "more_links": "More Links",
    "msrp": "MSRP",
    "multiple": "Multiple",
    "na": "N/A",
    "name": "Name",
    "nevermind": "Nevermind",
    "new": "New",
    "newOrders": "New Orders",
    "newPassword": "New Password",
    "next": "Next",
    "nickname": "Nickname",
    "no": "No",
    "noIssueDate": "No issue date",
    "noOptions": "No Options",
    "noPhone": "No Phone",
    "noResults": "No Results",
    "no_minimum": "No Minimum",
    "no_sales_reps": "No Sales Reps",
    "no_status": "No Status",
    "no_value": "No Value",
    "none": "None",
    "notActivated": "Not Activated",
    "notProcessed": "Not Processed",
    "notSet": "Not set",
    "not_applicable_abbr": "N/A",
    "note": "Note",
    "notes": "Notes",
    "notifications": "Notifications",
    "numOrdered": "{num} Ordered",
    "num_available": "{num} Available",
    "numberSelected": {
      "product": "<strong>{num} products</strong> selected | <strong>{num} product</strong> selected | <strong>{num} products</strong> selected"
    },
    "number_of_total_selected": "{num} of {total} selected",
    "off": "Off",
    "ok": "Ok",
    "okay": "Okay",
    "on": "On",
    "onBackorder": "On Backorder",
    "onHold": "On Hold",
    "onTheWay": "On The Way",
    "open": "Open",
    "optional": "optional",
    "optionalLabel": "(Optional)",
    "options": "Options",
    "or": "Or",
    "order": "Order",
    "orderAndBoxCount": "Order & Box Count",
    "orderDate": "Order Date",
    "orderDetails": "Order details",
    "orderFees": "Order Fees",
    "orderIssues": "Order Issues",
    "orderNumber": "Order Number",
    "orderType": "Order Type",
    "order_created": "Order created",
    "order_id": "Order ID",
    "order_minimum": "Order Minimum",
    "order_sort": "Order",
    "order_status": "Order Status",
    "order_summary": "Order Summary",
    "order_total": "Order Total",
    "orderedDate": "Ordered Date",
    "orders": "Orders",
    "ordersCount": "0 Orders | {count} Order | {count} Orders",
    "orderWithNumber": "Order {orderNumber}",
    "organizations": "Organizations",
    "other": "Other",
    "overdue": "Overdue",
    "owner": "Owner",
    "package": "Package",
    "packageId": "Package ID",
    "packageIds": "Package IDs",
    "packages": "Packages",
    "paid": "Paid",
    "paid_question": "Paid?",
    "partial": "Partial",
    "partiallyPaid": "Partially Paid",
    "password": "Password",
    "pay": "Pay",
    "payment": "Payment",
    "paymentMethod": "Payment Method",
    "paymentMethods": "Payment Methods",
    "paymentOnSellThrough": "Payment on Sell Through",
    "paymentOnSellThroughLong": "Payment on Sell-Through (PoST)",
    "paymentOptionDescriptions": {
      "cod": "Get paid via {method} from your buyer upon delivery",
      "consign": "Payment is due via {method} after goods have sold at retail",
      "llDirect": "Digital, B2B payment debited directly from your customer's bank account",
      "llFlexible": "Advanced payment from LeafLink following delivery confirmation",
      "llFlexibleRf": "Payment from LeafLink following delivery confirmation. Buyer is paying for extended terms.",
      "net": "Get paid via {method} from your buyer within {days} days of delivery",
      "prepay": "Get a pre-payment via {method} for your order"
    },
    "paymentOptions": "Payment Options",
    "payment_date": "Payment Date",
    "payment_type": "Payment Type",
    "payment_types": {
      "cashier": "Cashier"
    },
    "payments": "Payments",
    "paymentsAvailable": "Payments is available for this customer",
    "paymentsDirect": "LeafLink Direct Payment",
    "paymentsFlexible": "LeafLink Flexible Payment",
    "paymentsFlexibleRf": "Buyer purchased terms",
    "pending": "Pending",
    "pendingApproval": "Pending Approval",
    "perMonth": "per month",
    "phone": "Phone",
    "phoneNumber": "Phone number",
    "phonePlaceholder": "(555) 555-5555",
    "pick_a_date": "Pick a Date",
    "pick_a_day": "Pick a day",
    "pickup": "Pickup",
    "pickupDate": "Pickup Date",
    "pickupDateFrom": "Pickup Date From",
    "placedOn": "Placed on",
    "placeholder": {
      "phoneNumber": "(XXX) XXX-XXXX"
    },
    "placeholder_sales_reps": "Select sales reps",
    "planDetails": "Plan Details",
    "position": "Position",
    "postBadgeLabel": "PoST",
    "prev": "Prev",
    "preview": "Preview",
    "previous": "Previous",
    "previousVersion": "Previous Version",
    "price": "Price",
    "priceChange": "Price Change",
    "priceMaximum": "Price Maximum",
    "priceMinimum": "Price Minimum",
    "pricing": "Pricing",
    "primaryContact": "Primary Contact",
    "print": "Print",
    "privacyPolicy": "Privacy Policy",
    "processing": "Processing",
    "product": "Product",
    "productCount": "0 Products | {count} Product | {count} Products",
    "productList": "Product list",
    "product_line": "Product Line | Product Lines",
    "product_name": "Product Name",
    "product_status": "Product Status",
    "products": "Products",
    "promotional": "Promotional",
    "public": "Public",
    "purchasing": "Purchasing",
    "qty_short": "Qty",
    "quantity": "Quantity",
    "quantityAvailable": "Quantity Available",
    "readLess": "Read less",
    "readMore": "Read more",
    "reason": "Reason",
    "received": "Received",
    "received_date": "Received Date",
    "recentOrders": "Recent Orders",
    "recommended": "Recommended",
    "refresh": "Refresh",
    "reject": "Reject",
    "rejected": "Rejected",
    "remoteCustomer": "remote customer",
    "remoteProduct": "remote product",
    "remove": "Remove",
    "remove_contact": "Remove Contact",
    "removed": "Removed",
    "reprocessOrder": "Reprocess Order",
    "request": "Request",
    "request_sample": "Request Sample",
    "required": "Required",
    "requiredField": "This field is required.",
    "reserved": "Reserved",
    "resetOrder": "Reset order",
    "reset_filters": "Clear",
    "retailPrice": "Retail Price",
    "retailer": "Retailer",
    "review": "Review",
    "reviewBuyers": "Review Buyers",
    "routeDetails": "Route Details",
    "row": "Row",
    "sale": "Sale",
    "salePrice": "Sale Price",
    "salesRep": "Sales Representative",
    "sales_reps": "Sales Representatives",
    "sales_reps_short": "Sales Reps",
    "sample": "Sample",
    "save": "Save",
    "saveAndClose": "Save & Close",
    "saveAndContinue": "Save & Continue",
    "saveChanges": "Save Changes",
    "schedule": "Schedule",
    "search": "Search",
    "search_by": "Search by",
    "search_term": "Search Term",
    "secondary_email": "Secondary Email",
    "secondary_phone": "Secondary Phone",
    "seeResults": "See Results",
    "selectAll": "Select all",
    "selectAllCount": "Select all ({count})",
    "selectCountFromTotal": "Select {count} of {total}",
    "selectCustomer": "Select Customer",
    "selectLocation": "Select Location",
    "selectState": "Select State",
    "selectStateToBegin": "Select a state to begin",
    "selectTimezone": "Select Time Zone",
    "select_all_that_match": "Select all matching search and filters",
    "select_item": "Select Item",
    "select_one": "Select One",
    "seller": "Seller",
    "send": "Send",
    "sendBackToCart": "Send back to cart",
    "sendMessage": "Send Message",
    "service_zone": "Service Zone",
    "settings": "Settings",
    "shipFrom": "Ship from",
    "shipTo": "Ship To",
    "ship_date": "Ship Date",
    "ship_date_modified": "Ship Date Last Modified",
    "shipping": "Shipping",
    "shippingCharge": "Shipping charge",
    "shippingDetails": "Shipping details",
    "shopBy": "Shop By",
    "shop_brands": "Shop Brands",
    "shop_products": "Shop Products",
    "show": "Show",
    "show_all": "Show All",
    "showing_num_of_total_results": "Showing {num} of {total} results",
    "signUp": "Sign Up",
    "skip": "Skip",
    "sku": "SKU",
    "sku_number": "SKU: {sku}",
    "sku_quantity": "SKU Quantity",
    "sold": "Sold",
    "soldBy": "Sold By",
    "sort": "Sort",
    "sortAllBy": "Sort all by",
    "sortBy": "Sort by",
    "source": "Source",
    "split": "Split",
    "staff": "Staff",
    "start_date": "Start Date",
    "state": "State",
    "status": "Status",
    "status_question": "Status?",
    "steps": "Step {step} of {steps}",
    "store": "Store",
    "storeAndSalesRep": "Store & Sales Rep",
    "storeHours": "Store Hours",
    "storedBy": "Stored By",
    "strain": "Strain",
    "strainClassification": "Strain Classification",
    "strain_name": "Strain Name",
    "strains": "Strains",
    "subcategory": "Subcategory",
    "subject": "Subject",
    "submit": "Submit",
    "submitted": "Submitted",
    "submittedBy": "Submitted by",
    "subtotal": "Subtotal",
    "subtracted": "Subtracted",
    "success": "Success",
    "suggested": "Suggested",
    "system": "System",
    "tag": "Tag",
    "tags": "Tags",
    "task": "Task",
    "tasks": "Tasks",
    "tax": "Tax",
    "tdp": "TDP",
    "templates": "Templates",
    "terms": "Terms",
    "termsAndConditions": "Terms and Conditions",
    "termsOfService": "Terms of Service",
    "territories": "Territories",
    "text": "Text",
    "thanks": "Thanks",
    "thc": "THC",
    "thcMaximum": "THC Maximum",
    "thcMinimum": "THC Minimum",
    "thca": "THCa",
    "thcd10": "D-10 THC",
    "thcd8": "D-8 THC",
    "thcv": "THCv",
    "thcva": "THCva",
    "tier": "Tier {num}",
    "timezone": "Timezone",
    "title": "Title",
    "to": "To",
    "topic": "Topic",
    "total": "Total",
    "totalAmount": "Total Amount",
    "totalCannabinoid": "Total Cannabinoid",
    "totalCannabinoids": "Total Cann",
    "totalCaseQuantity": "Total Case Quantity",
    "totalItems": "Total Items",
    "totalPrice": "Total Price",
    "totalThc": "Total THC",
    "totals": "Totals",
    "true": "True",
    "tryAgain": "Try Again",
    "twitter": "X",
    "type": "Type",
    "type_to_search": "Type to search",
    "unassigned": "Unassigned",
    "unavailable": "Unavailable",
    "unavailableOrders": "Unavailable Orders",
    "unfulfilled": "Unfulfilled",
    "unit": "Unit",
    "unitCount": "0 Units | {count} Unit | {count} Units",
    "unitNumber": "Unit Number",
    "unitOfMeasure": "Unit of Measure",
    "unitPrice": "Unit Price",
    "units": "Units",
    "unitWeight": "Unit Weight",
    "unlimited": "Unlimited",
    "unlinkPackage": "Unlink {packageTerm}",
    "unpaid": "Unpaid",
    "unprocessed": "Unprocessed",
    "update": "Update",
    "updateBy": "Update By",
    "updatePassword": "Update Password",
    "upload": "Upload",
    "uploadInvoice": "Upload Invoice(s)",
    "uploadedDate": "Uploaded Date",
    "uploading": "Uploading",
    "user": "User",
    "username": "Username",
    "users": "Users",
    "validate": "Validate",
    "validating": "Validating",
    "varieties": "Varieties",
    "varietiesCount": "0 varieties | 1 variety | {num} varieties",
    "variety": "Variety",
    "vehicle": "Vehicle",
    "vendor": "Vendor",
    "verified": "Verified",
    "view": "View",
    "viewAll": "View All",
    "viewAllType": "View All {type}",
    "viewBillingInfo": "View Billing Info",
    "viewDocument": "View Document",
    "viewOrderLog": "View Order Log",
    "viewing": "Viewing",
    "warehouse": "Warehouse",
    "warning": "Warning",
    "website": "Website",
    "websitePlaceholder": "https://www.example.com",
    "whatsNext": "What's Next?",
    "wholesale": "Wholesale",
    "wholesalePrice": "Wholesale Price",
    "xTwitter": "X / Twitter",
    "yes": "Yes",
    "youtube": "YouTube",
    "zipPostalCode": "Zip Code/Postal Code",
    "zipcode": "Zip Code",
    "zipcodes": "Zip Codes",
    "zone": "Zone",
    "zones": "Zones"
  },
  "companySettings": {
    "addRecipients": "Add Recipient(s)",
    "contactHeader": "Delivery Contact Info",
    "contactSubHeader": "These preferences are used for orders delivered through LeafLink transportation services.",
    "deliveryInstructions": "Delivery Instructions",
    "deliveryInstructionsHint": "Additional instructions to be followed when your orders are delivered.",
    "editHours": "Edit Hours",
    "emailAddressForNotifications": "Email Address (for notifications)",
    "metrcAPIKey": {
      "enterMetrcAPIKey": "Enter Metrc API Key",
      "errorValidatingAPIKey": "Your key is expired or invalid. Please enter and submit a new key",
      "invalidAPIKey": "This key is expired or invalid.",
      "manifestGeneratorAPIKey": "Metrc Transfer Template Generator",
      "metrcAPIKey": "Metrc API Key"
    },
    "notificationPreference": "Notification Preference",
    "notificationRecipientBuyerHint": "Select the staff member who will receive automatic notifications for orders delivered through LeafLink transportation services.",
    "notificationRecipients": "Notification Recipient(s)",
    "notificationRecipientsSellerHint": "Specify staff members to receive automatic notifications from LeafLink Transportation Services.",
    "notificationType": "Notification Type",
    "notificationTypes": {
      "plannedRoutes": "Planned Routes",
      "vehicleTracking": "Vehicle Tracking",
      "vehicleTrackingTooltip": "Only one staff member can receive this notification type"
    },
    "pickupInstructions": "Pickup Instructions",
    "pickupInstructionsHint": "Additional instructions to be followed when your orders are picked up",
    "pickupWindows": "Pickup Windows",
    "pointContactSettings": {
      "onCallFor": "On call for",
      "pickupNotificationType": "Pickup Notification Type",
      "pointOfContact": "Point of Contact"
    },
    "pointsOfContact": "Point(s) of Contact",
    "preference": "Preference",
    "recipient": "Recipient",
    "removeNotificationRecipient": "Remove Notification Recipient?",
    "removeNotificationRecipientDescription": "This person will no longer receive notifications, but will remain a point of contact.",
    "selectDayAndTime": "Select Day and Time",
    "shippingPreferences": "Shipping Preferences",
    "shippingPreferencesSubheader": "These preferences are used for orders shipped through <a href=\"https://www.leaflink.com/product/leaflink-logistics\" target=\"_blank\">LeafLink transportation services.</a>",
    "storeHoursNotBlank": "Open and close times cannot be blank if \"Closed\" is not selected.",
    "tmsNotificationRecipient": "Notification Recipient"
  },
  "constants": {
    "activation_statuses": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "backfillJobStatuses": {
      "cancelled": "Cancelled",
      "failed": "Failed",
      "pending": "Pending",
      "success": "Success"
    },
    "bringgTaskStatuses": {
      "failed": "Failed",
      "pending": "Not Pushed",
      "success": "Successful"
    },
    "buyerVerificationStatuses": {
      "unverified": "Unverified",
      "verified": "@:common.verified"
    },
    "checkboxStatuses": {
      "all": "All",
      "selected": "Selected",
      "unselected": "Unselected"
    },
    "classifications": {
      "adultUse": "Adult Use",
      "ancillary": "Ancillary",
      "cannabis": "Cannabis",
      "combined": "Combined",
      "medical": "Medical",
      "none": "No Classification"
    },
    "createOrderSortBy": {
      "manual": "Manual (Drag to re-order)",
      "productLineAsc": "Product Line (A to Z)",
      "productNameAsc": "Product Name (A to Z)",
      "skuAsc": "SKU (A to Z)"
    },
    "credit_reasons": {
      "other": "Other",
      "promo_existing_customer": "Promo - Existing Customer",
      "promo_new_customer": "Promo - New Customer",
      "return_defective": "Return - Defective",
      "return_expired": "Return - Expired",
      "return_order_issue": "Return - Order Issue",
      "return_other": "Return - Other",
      "return_packaging": "Return - Packaging"
    },
    "credit_statuses": {
      "active": "Active",
      "cancelled": "Cancelled",
      "used": "Used"
    },
    "inboundLeadsStatuses": {
      "complete": "Complete",
      "ignored": "Ignored",
      "pending": "Pending"
    },
    "inboundLeadsTypes": {
      "general": "General",
      "informationRequest": "Information Request",
      "notifyMe": "Notify Me",
      "productInquiry": "Product Inquiry",
      "sampleRequest": "Sample Request"
    },
    "invoiceStatus": {
      "makePayment": "Make Payment"
    },
    "leadInfo": {
      "itemAddedToCart": "Product added to cart",
      "itemViewed": "Product viewed",
      "menuViewed": "Menu viewed"
    },
    "logisticsOrderStatuses": {
      "assigned": "Assigned",
      "delivered": "Delivered",
      "planned": "Planned",
      "shipped": "Shipped",
      "uploaded": "Uploaded"
    },
    "metrcTransferErrors": {
      "cannotDetermineLicense": "Metrc manifest build failed because a single license cannot be identified for this order. Manifest generator supports orders with one license at this time. Please confirm that the products and the customer have accurate licenses set.",
      "metrcClientError": "Metrc manifest build failed. Please try again later."
    },
    "metrcTransferStatuses": {
      "available": {
        "name": "Available",
        "tooltip": "The manifest is available in your Metrc account."
      },
      "error": {
        "name": "Error",
        "tooltip": "There was a problem generating your manifest.  Click to learn more."
      },
      "generating": {
        "name": "Generating",
        "tooltip": "Generating transfer. Please refresh page to see updated status."
      },
      "notStarted": {
        "name": "Not Started",
        "packingAppEnabledTooltip": "The Metrc Manifest will be generated when the order reaches the Planned status and totes have been scanned in Ship Assist.",
        "tooltip": "The Metrc Manifest will be generated when the package tags are marked ready on the order and the order reaches the Planned status.",
        "wmsTooltip": "The Metrc Manifest will be generated when the order reaches Planned status and Package Tags have been captured in the WMS."
      }
    },
    "orderPaymentTypes": {
      "fullPayment": "Full payment",
      "partialPayment": "Partial payment"
    },
    "orderStatuses": {
      "accepted": "Accepted",
      "backorder": "Backorder",
      "backordered": "Backordered",
      "cancelled": "Cancelled",
      "combined": "Combined",
      "complete": "Complete",
      "delivered": "Delivered",
      "draft": "Draft",
      "error": "Error",
      "fulfilled": "Fulfilled",
      "pending": "Pending",
      "rejected": "Rejected",
      "shipped": "Shipped",
      "submitted": "Submitted",
      "unknown": "Unknown"
    },
    "paymentMethods": {
      "ach": "ACH",
      "cash": "Cash",
      "cashiersCheck": "Cashier's Check",
      "check": "Check",
      "credit": "Credit",
      "leaflinkFinancial": "LeafLink Financial",
      "other": "Other",
      "trade": "Trade",
      "wireTransfer": "Wire Transfer"
    },
    "requiredAction": {
      "linkCustomer": "Link Customer",
      "title": "Required Action",
      "verifyBuyer": "Verify Buyer"
    },
    "returnReasons": {
      "defective": "Defective",
      "expired": "Expired",
      "orderIssue": "Order Issue",
      "other": "Other",
      "packagingIssue": "Packaging Issue",
      "rejected": "Rejected"
    },
    "returnStatuses": {
      "complete": "Complete",
      "rejected": "Rejected",
      "submitted": "Submitted"
    },
    "taskStatuses": {
      "done": "Done",
      "inProgress": "In Progress",
      "todo": "To Do"
    },
    "timePeriods": {
      "day": "days",
      "hour": "hrs",
      "week": "weeks"
    }
  },
  "directPaySignupModal": {
    "body": "Power your business forward with a B2B payment solution that pays you upfront and protects you from risk. We’ll help you get paid faster, so you can gain access to working capital and streamline your entire accounting process, all from a single platform.",
    "headerMultiple": "{numberOfBuyers} buyers are waiting to pay you via Direct Pay",
    "headerSingle": "{companyName} wants to pay you via Direct Pay.",
    "maybeLater": "Maybe later"
  },
  "featureEnrollment": {
    "onExitingDialog": {
      "cancelButtonText": "Take Me Back",
      "confirmButtonText": "Exit",
      "description": "If you exit, your progress towards activating LeafLink Plus will be lost.",
      "header": "Are you sure you want to exit?"
    }
  },
  "forms": {
    "placeholders": {
      "email": "Enter an email address"
    },
    "validation": {
      "email": "Enter a valid email address"
    }
  },
  "integrations": {
    "biotrack": "BioTrack",
    "metrc": "Metrc"
  },
  "inventoryInsights": {
    "activateLeafLinkPlus": "Activate LeafLink Plus",
    "activateYourFreeTrial": {
      "description": "By clicking Start Free Trial, you are agreeing to our {link} and signing up for the monthly subscription plan. Your payment method will be charged the specified price (plus any applicable taxes) when your trial ends on the date listed. You can cancel at any time; please note that there are no refunds for partially unused periods.",
      "link": "Terms of Service",
      "title": "Activate your free trial now"
    },
    "addAPIKey": "Add API Key",
    "addFlowhubCredentials": "Add Client ID and Location ID",
    "alertsLeafLinkPlus": {
      "alreadyEnrolled": "This Location is already enrolled in LeafLink Plus",
      "nonAdminAlert": "Admin access is required to Activate LeafLink Plus"
    },
    "apiKey": "API Key",
    "billingInformation": "Billing Information",
    "billingInformationDescription": "You’ll also need a credit card or bank account info available if you haven’t previously paid for LeafLink’s services.",
    "billingSetup": {
      "addNewPaymentMethod": "Add a new payment method or continue with your existing default payment method:",
      "bankAccounts": "<span class=\"tw-font-weight-400 tw-text-ice-900\">Bank Accounts</span> are managed through a secure Plaid link. Just follow the prompts.",
      "billingContact": "Billing Contact",
      "billingUpdates": "All billing updates will be sent to this email address:",
      "creditCards": "<span class=\"tw-font-weight-400 tw-text-ice-900\">Credit Cards</span> are managed in a separate secure portal which will open in another tab. Close the tab when you’re done.",
      "editBillingContact": "Edit Billing Contact",
      "loadPaymentMethod": "It may take up to 15 seconds to load your payment method"
    },
    "clientId": "Client ID",
    "dashboardCTA": {
      "activate": "Activate Inventory Insights",
      "analyze": "Analyze sell-through trends to source alternative products",
      "chip": "Inventory Insights",
      "identify": "Identify high-performing products to inform replenishment",
      "negotiate": "Negotiate pricing based on velocity and performance",
      "title": "Take action on sales data to improve your margins"
    },
    "dueToday": "Due Today",
    "dutchie": "Dutchie",
    "dutchieLinkNameStepDescription": "Name of the third-party integrator (LeafLink)",
    "dutchieLocationsStepDescription": "Location(s) you want to connect to LeafLink",
    "enrollment": {
      "activateInventoryInsights": "Activate Inventory Insights",
      "afterClickingGetStarted": "After clicking Activate Inventory Insights:",
      "faq": {
        "access": "When do I get access to Inventory Insights?",
        "accessAnswer": "After integrating your POS and S2S systems, your inventory insights reports will be ready in about 24 hours.",
        "biotrack": "I’m in a BioTrack market - can I sign up?",
        "biotrackAnswer": "Yes! After completing the activation process, go to your Settings → Manage Licenses page and enter your BioTrack credentials to get started with Inventory Insights.",
        "pos": "Which point of sale systems do you support?",
        "posAnswer": "We currently support Dutchie and are actively working on adding more POS systems. Let us know you're still interested by joining the waitlist.",
        "pricing": "How much does it cost?",
        "pricingAnswer": "Inventory Insights is free when you integrate your POS and S2S systems. At this point, we cannot offer Inventory Insights without those requirements, but the program may change in the future.",
        "subtitle": "Some general questions retailers have about Inventory Insights"
      },
      "flexiblePaymentMethods": "Access to Flexible Payment Methods",
      "flexiblePaymentMethodsDescription": "Share sell-through data with the vendors you choose and get access to Payment on Sell-Through.",
      "getStarted": "Get Started Free",
      "inventoryInsightsReportBullet": "Your first Inventory Insights report will be generated within 24 hours of setting up your POS and seed to sale integrations.",
      "inventoryInsightsReporting": "Inventory Insights Reporting",
      "inventoryInsightsReportingDescription": "Unlock value-added analysis on the products you purchase on LeafLink to prevent stockouts on best-sellers and avoid aging inventory.",
      "nextSteps": "Next Steps",
      "posAPIKeys": "Point of Sale API Keys",
      "posAPIKeysDescription": "You will need to connect your POS with LeafLink through a secure integration. Your information is not shared with any other party.",
      "s2sAPIKeys": "Your Seed to Sale API Key",
      "s2sAPIKeysDescription": "All authorization is done securely, and we do not push data to your seed to sale account without your express authorization.",
      "s2sEmailBullet": "You will receive an email with instructions for adding your Metrc or BioTrack API key - you can also go to your “Manage Licenses” page in Settings to add your API key.",
      "subtitle": "Power up your purchasing through a secure point of sale integration.",
      "successModal": {
        "dailyActionReportDescription": "Reveal the products that need better margins.",
        "dailyActionReportTitle": "Daily Action Report",
        "enterS2SApiKey": "Enter Seed to Sale API Key",
        "insightsDescription": "See actionable tips on product listings based on sales velocity and what's in stock.",
        "insightsTitle": "Native Insights",
        "intro": "You’re all signed up! Your first Inventory Insights report will be generated within 24 hours of setting up your POS and seed to sale integrations.",
        "inventoryInsightsAccess": "Once you’ve entered your seed to sale API key, you’ll have full access to Inventory Insights, including:",
        "leaderboardDescription": "See products ranked by profitability across all the categories you stock.",
        "leaderboardTitle": "Daily Product Leaderboard",
        "title": "Inventory Insights"
      },
      "terms": "By clicking Activate Inventory Insights, you are agreeing to our {link}.",
      "title": "Optimize inventory turnover, reduce stockouts, and maximize margins with Inventory Insights",
      "whatYouGet": "What you get",
      "whatYoullNeed": "What you'll need",
      "yourInformation": "Your Information"
    },
    "enterAPIKey": "You must add an API Key to continue",
    "enterClientId": "You must add a Client ID to continue",
    "enterEmailAddress": "Enter Email Address",
    "enterLocationId": "You must add a Location ID to continue",
    "findAPIKey": "How do I find my Dutchie API key?",
    "findFlowhubCredentials": "How do I find my Flowhub Client ID and Location ID?",
    "firstPaymentDue": "First payment due",
    "flowhub": "Flowhub",
    "flowhubLinkNameStepDescription": "Complete the request form with LeafLink selected as your integration partner",
    "flowhubLocationsStepDescription": "Flowhub will provide the following IDs for each of your locations:",
    "getStarted": "To get started, you'll need a point of sale system that's integrated with LeafLink. Select a supported system to learn more:",
    "invalidAPIKey": "API Key not valid",
    "invalidDutchieInputMessage": "Your API key doesn’t match Dutchie’s records. Check for typos before reentering it below.",
    "invalidFlowhubInputMessage": "One or more of your IDs doesn’t match Flowhub’s records. Check for typos before reentering them below.",
    "inventoryInsightsIntegration": "Inventory Insights Integration with POS",
    "leaflinkPlusMonthlySubscription": "LeafLink Plus Monthly Subscription",
    "license": "License",
    "linkDutchie": "To link your Dutchie POS system to LeafLink, email {link} with the following information:",
    "linkFlowhub": "To link your Flowhub POS system to LeafLink, navigate to {link}:",
    "locationDetails": "Location Details",
    "locationId": "Location ID",
    "moreInformation": {
      "dutchieLinkLabel": "Dutchie's help center",
      "dutchieText": "For more information, visit {link}",
      "flowhubLinkLabel": "help{'@'}flowhub.com",
      "flowhubText": "For more information, contact {link}"
    },
    "notSeeingPOS": {
      "description": "We're actively working on adding more POS systems. Let us know you're still interested by {link}.",
      "linkLabel": "joining the waitlist",
      "title": "Not Seeing Your POS?"
    },
    "nueIntegration": {
      "description": "By clicking Activate Now, you are agreeing to our {link} and signing up for the monthly subscription plan. Your payment method will be charged the specified price (plus any applicable taxes) when your trial ends on the date listed. You can cancel at any time; please note that there are no refunds for partially unused periods.",
      "freeTrial": {
        "description": "By clicking Start Free Trial, you are agreeing to our {link} and signing up for the monthly subscription plan. Your payment method will be charged the specified price (plus any applicable taxes) when your trial ends on the date listed. You can cancel at any time; please note that there are no refunds for partially unused periods.",
        "title": "Activate your {unit}-{type} free trial now"
      },
      "title": "Activate your subscription now"
    },
    "paymentRequiredDialog": {
      "acknowledge": "Acknowledge",
      "description": "To continue, a valid payment method must be added.",
      "paymentRequired": "Payment Method Required"
    },
    "posProvider": "POS Provider",
    "posSystemRequired": "POS System is required",
    "reenterClientId": "Reenter Client ID",
    "reenterLocationId": "Reenter Location ID",
    "separateApiKey": "Each location will need a separate API Key",
    "specifyLocation": "Specify the exact location name(s) as they appear in the Dutchie POS Backoffice",
    "startFreeTrial": "Start Free Trial",
    "steps": {
      "billingSetup": "Billing Setup",
      "connectYourPOS": "Connect Your POS",
      "reviewInformation": "Review Information",
      "whatYoullNeed": "What You'll Need"
    },
    "successModalLeafLinkPlus": {
      "description": "You’re all signed up! Here’s what your LeafLink Plus subscription unlocks:",
      "reportsList": {
        "accountingIntegrations": {
          "description": "Simplify your finance department’s workflows with integrations like QuickBooks and Sage. Reach out to your account manager or <a href=\"mailto:account_management{'@'}leaflink.com?subject=LeafLink Plus Accounting Integrations Inquiry\" class='tw-text-blue-500 tw-underline'>account_management{'@'}leaflink.com</a> to learn more.",
          "title": "Accounting Integrations"
        },
        "cashBack": {
          "description": "Earn cash back on every purchase when you pay with LeafLink’s Pay on Sell-Through offering.",
          "title": "Cash Back"
        },
        "inventoryInsights": {
          "description": "Explore which products will drive profitability. Leave the spreadsheets behind and head over to your Reports tab. It may take up to 24 hours for your data to appear.",
          "title": "Inventory Insights"
        }
      },
      "title": "LeafLink Plus Activated"
    },
    "supportedPOSProvider": "Supported POS Provider",
    "upgradeLeafLinkPlusPage": {
      "buttons": {
        "startFreeTrialOfLeafLinkPlus": "Start Free Trial of LeafLink Plus"
      },
      "features": {
        "cards": {
          "accountingIntegrations": "Make your technology work for you with {0} designed to make growing your business organized, efficient, and stress-free.",
          "inventoryInsights": "Skip the spreadsheets! Let LeafLink crunch the numbers with daily {0} to help you save time and boost your profit margins."
        },
        "title": "Powerful Features, Maximum Impact"
      },
      "footer": {
        "description": "Time is money! Act fast to unlock exclusive tools - and your business’s full potential - with LeafLink Plus. Secure payments, real-time insights, and more are just a click away. Get started now!"
      },
      "header": {
        "description": "Take your business to the next level with seamless access to exclusive tools, including payment flexibility and real-time inventory tracking.",
        "title": "Get more out of LeafLink!"
      },
      "plans": {
        "leafLinkAccess": "LeafLink Access",
        "leafLinkPlus": "LeafLink Plus",
        "list": {
          "accountingIntegrations": {
            "description": "Easily centralize finances and streamline your workflows.",
            "title": "Accounting Integrations"
          },
          "directPay": {
            "description": "Pay sellers directly and save with fee-free ACH payments.",
            "title": "Direct Pay"
          },
          "inventoryInsights": {
            "description": "Optimize inventory, eliminate stockouts, and maximize sales.",
            "title": "Inventory Insights"
          },
          "marketplace": {
            "description": "Browse and buy from thousands of trusted wholesale cannabis sellers.",
            "title": "Marketplace"
          },
          "paymentOnSellThrough": {
            "description": "Reduce upfront costs and risks by paying for inventory when it sells.",
            "title": "Payment on Sell-Through"
          }
        },
        "perStore": "per store"
      }
    },
    "validateEmail": "Enter a valid email address to proceed"
  },
  "layout": {
    "companyStatus": {
      "companyNotLive": "{company} is not yet Live on the marketplace",
      "companyNotLiveTooltipBuyer": "To set your account to Live on LeafLink contact support{'@'}leaflink.com",
      "companyNotLiveTooltipSeller": "Your menu is not visible to buyers on LeafLink yet. Reach out to your Onboarding Lead and they can help make your account public. Remember to complete your onboarding checklist before going live!",
      "currentlyManaging": "Currently managing {company}",
      "notifyInvoicesPastDue": {
        "adminAction": "If you have questions, email billing{'@'}leaflink.com including your company's name and state/territory.",
        "daysToBePaused": "Resolve any unpaid invoices within 7 days of the due date to avoid account interruptions.",
        "daysToBePausedCountdown": "Your account will be paused in {daysToBePaused} day.",
        "daysToBePausedCountdownPlural": "Your account will be paused in {daysToBePaused} days.",
        "line1": "You have {num} bill past due",
        "line1Plural": "You have {num} bills past due",
        "nonAdminAction": "Please contact your admin."
      },
      "updateLicenses": "Please send us your updated licenses"
    },
    "sideNav": {
      "activityFeed": "Activity Feed",
      "adminTools": "Admin Tools",
      "advertising": "Advertising",
      "buyItAgain": "@:common.buyItAgain",
      "buyerReports": "Buyer Reports",
      "catalog": "Catalog",
      "customers": "Customers",
      "dashboard": "Dashboard",
      "deliveries": "Deliveries",
      "discoverProducts": "Discover Products",
      "fulfillment": "Fulfillment",
      "inventory": "Inventory",
      "messages": "@:common.messages",
      "orderDeliveries": "Order Deliveries",
      "orders": "Orders",
      "payments": "Payments",
      "previewMenu": "Preview Menu",
      "pricing": "Pricing",
      "purchasingInsights": "Purchasing Insights",
      "reports": "Reports",
      "salesDashboard": "Sales Dashboard",
      "seedToSale": "Seed to Sale",
      "sellerReports": "Seller Reports",
      "settings": "Settings",
      "shipAssist": "Ship Assist",
      "shipping": "Shipping",
      "shop": "Shop",
      "shopBrands": "Shop Brands",
      "shopProducts": "Shop Products",
      "warehouse": "Warehouse"
    },
    "userProfile": {
      "logout": "Logout",
      "manageProfile": "Manage Profile",
      "notificationPreferences": "Notification Preferences",
      "referRetailer": "Refer a Retailer, Earn $50",
      "releaseNotes": "Release Notes",
      "shareLeafLink": "Share LeafLink",
      "shareMenu": {
        "dialog": {
          "selectLicenseType": {
            "description": "Choose the license you wish to simulate for the downloaded menu. This ensures that products displayed to users align with the licenses they are eligible to purchase.",
            "selectBuyerLicenseType": "Select Buyer License Type"
          }
        },
        "emailModal": {
          "downloadPDF": "Download PDF",
          "existingCustomers": "Existing Customers",
          "goToMenuLink": "Go to Menu Link",
          "goToOrderForm": "Go to Order Form",
          "hey": "Hey",
          "message": "Message",
          "previewEmail": "Preview Email",
          "recipient": "Recipient",
          "recipients": "Recipients",
          "sendEmail": "Send Email",
          "submitShareMenu": "Share Menu",
          "submitShareOrderForm": "Share Order Form",
          "title": "Share Menu via Email",
          "titleOrderForm": "Share Order Form via Email",
          "yourMessagePlaceholder": "your message will go here"
        },
        "linkText": "Share Menu",
        "modal": {
          "comingSoon": "Coming soon!",
          "description": {
            "leafLinkUsers": "LeafLink users will be directed to the logged-in brand menu experience and navigate through the standard ordering process.",
            "nonLeafLinkUsers": "Non-LeafLink users will be linked to your Public Menu and must register to order. By default, public menus do not display pricing, available quantities, or internal products. To update your public menu settings visit {settings}.",
            "orderFormLeafLinkUsers": "Logged-in users will be directed to our new Order Form experience.",
            "orderFormNonLeafLinkUsers": "Logged-out users must verify their identity to view the new Order Form experience.",
            "settings": "Choose what information you’d like to show on your custom menu"
          },
          "disclaimer": "By sharing this menu link, you acknowledge that LeafLink does not verify the license status or business credentials of any retailer that has not logged into a LeafLink account. You are responsible for verifying retailer information prior to fulfillment, compliance with applicable law, and any unauthorized sharing or misuse of the link.",
          "labels": {
            "availableProductQuantities": "Available product quantities",
            "brandBanner": "Brand banner",
            "brandLogo": "Brand logo",
            "brandTaglineDescription": "Brand tagline & description",
            "buyerLicenseType": "Buyer license type",
            "contactInfo": "Contact info",
            "copy": "Copy",
            "copyMenuLink": "Copy Menu Link",
            "createOrderForm": "Create Order Form",
            "defaultMenu": "Default Menu",
            "howDoLinksWork": "How do menu links work?",
            "howDoOrderFormLinksWork": "How do Order Form links work?",
            "leafLinkUsers": "LeafLink users",
            "link": "Link",
            "menuSettings": "Menu settings",
            "menuType": "Menu type",
            "nonLeafLinkUsers": "Non-LeafLink users",
            "orderForm": "Order Form",
            "orderFormLeafLinkUsers": "Logged-in LeafLink Users",
            "orderFormNonLeafLinkUsers": "Logged-out LeafLink Users",
            "otherWaysToShare": "Other ways to share",
            "productImages": "Product images",
            "selectMenuToShare": "Select menu to share",
            "shareOptions": "Share Options",
            "shareToSocials": "Share to Socials",
            "shareViaMenuLink": "Share via menu link",
            "showInternalProducts": "Products marked as internal",
            "showOnMenu": "Show on menu...",
            "showProductImages": "Product images",
            "showQuantities": "Available product quantities"
          },
          "title": "Share Menu"
        },
        "sendOrderForm": "Send Order Form",
        "successDownloadModal": {
          "description": "A PDF menu has been sent to the email associated with your LeafLink account.",
          "headline": "PDF Download Started",
          "timeToDownload": "Please allow up to 5 minutes for it arrive in your inbox.",
          "title": "Download Menu"
        },
        "successEmailModal": {
          "description": "A link to your digital menu and a copy of the PDF menu has been sent to your recipient(s).",
          "descriptionOrderForm": "A link to your order form has been sent to your recipient(s).",
          "headline": "Your menu has been shared successfully",
          "headlineOrderForm": "Your order form has been shared successfully",
          "timeToArrival": "Please allow up to 5 minutes for it to arrive in their inbox."
        }
      }
    }
  },
  "legacy": {
    "accounting": {
      "archived_question": "Archived?",
      "clear_mapping": "Clear Mapping",
      "clear_mapping_success": "Successfully cleared mapping.",
      "create_on_quickbooks": "Create on QuickBooks",
      "custom_fields": "Custom Fields",
      "customer_mapping": "Customer Mapping",
      "customer_name": "Customer Name",
      "customer_not_mapped_to_quickbooks": "The customer, {name}, on this order has not yet been mapped to a QuickBooks customer. Please select the QuickBooks customer you'd like to map to.",
      "discount_account": "Discount Account",
      "fetch_order_line_items_error": "This order doesn't have any line items! Please add a line item before pushing to QuickBooks.",
      "inactiveCustomer": "Inactive Customer",
      "inactiveCustomerDescription": "The customer, {name}, has been deactivated in Quickbooks. Please select the QuickBooks customer you'd like to map to.",
      "map_invoice_before_push": "You must map these resources before the invoice can be pushed.",
      "parent_product_question": "Parent Product?",
      "product_mapping": "Product Mapping",
      "push_invoice": "Push Invoice",
      "pushed_to_quickbooks_success": "Successfully pushed order '{number}' for '{company}' to QuickBooks.",
      "pushing_invoice_to_quickbooks": "Pushing Invoice to QuickBooks",
      "quickbooks": "QuickBooks",
      "quickbooks_customer": "QuickBooks Customer",
      "quickbooks_item": "QuickBooks Item",
      "resources_mapped_to_quickbooks": "All resources have been mapped to QuickBooks. You can push the invoice now.",
      "unmapped_customer": "Unmapped Customer",
      "update_discount_account": "Successfully updated discount account."
    },
    "attach": "Attach",
    "connected": "Connected",
    "connected_to_metrc_item": "Connected to a Metrc Item",
    "create_customer_in_quickbooks": "Create Customer in QuickBooks",
    "create_non_inventory_product_confirmation": "This will create a new non-inventory product in QuickBooks. The product type and other details can be edited in QuickBooks after creation.",
    "create_quickbooks_item": "Create Item in QuickBooks",
    "customers": {
      "account_delinquency": "Account Delinquency",
      "add_activity": "Add Activity",
      "add_contact": "Add Contact",
      "add_customer_status": "Add Customer Status",
      "add_customer_status_heading": "Add New Customer Status",
      "add_existing_contact_to_customer": "Add an Existing Contact to this Customer",
      "all_accounts": "All Accounts",
      "archive_customer": "Archive Customer",
      "archive_customer_confirm": "Are you sure you want to archive '{customer}'?",
      "archive_customer_error": "Unable to archive customer '{customer}'.",
      "archive_customer_success": "Archived customer '{customer}'.",
      "associate_contact_success": "{name} associated to this customer.",
      "back_to_contact_picker": "Go Back to Contact picker",
      "buttonText": "Button Text",
      "check_archived_records_question": "Check Archived Records?",
      "choose_existing_contact": "Choose an existing Contact to add",
      "contacts": "Contacts",
      "create_contact": "Create Contact",
      "create_contact_error": "Error creating contact.",
      "create_contact_success": "{name} contact created.",
      "create_customer_status_success": "Customer status created.",
      "create_new_contact_for_customer": "Create a new Contact for this Customer",
      "create_new_contact_heading": "Create a New Contact",
      "customer_has_leaflink_account": "This customer has an account on LeafLink.",
      "customer_has_no_leaflink_account": "This customer does not have an account on LeafLink.",
      "customer_is_archived": "This customer is currently archived.",
      "customer_list_search_placeholder": "Search for Name, License #, Status, Tags, or Sales Rep",
      "customer_status_name": "Customer Status Name",
      "customer_status_placeholder": "e.g. Prospect",
      "customer_tier": "Customer Tier",
      "delete_customer_status_confirm": "Are you sure you want to delete this custom status? This action is not reversible.",
      "delinquent": "Delinquent",
      "dontSeePOC": "Don't see a point of contact?",
      "downloading": "CRM Downloading. Please note that filters on this page are reflected in the accompanying file.",
      "edit_customer_status_heading": "Edit New Customer Status",
      "emailErrorText": "You have exceeded the maximum character limit of 800",
      "emailMenu": "Email Menu",
      "exampleEmail": "Example Email",
      "export_crm": "Download CRM",
      "fetch_all_contacts_error": "Could not fetch contacts.",
      "fetch_customer_contacts_error": "Could not fetch customer contacts.",
      "fetch_customers_error": "Unable to fetch customers.",
      "fetch_service_zones_error": "Unable to fetch service zones.",
      "fetch_statuses_error": "Unable to fetch customer CRM statuses.",
      "good_standing": "Good Standing",
      "hyperlink": "Text will be displayed as a hyperlink",
      "license_type_placeholder": "e.g. Recreational",
      "loading_customers": "Loading Customers",
      "make_contact_primary_error": "Error setting contact as primary",
      "make_contact_primary_success": "Contact set as primary",
      "messagePlaceholder": "Here's a quick link to our brand menu with updated products!",
      "modify_status_permission_error": "You don't have permission to modify {name}.",
      "next_contact_date": "Next Contact Date",
      "no_custom_statuses_created": "You have not created any custom statuses.",
      "no_date_set": "No Date Set",
      "no_zone": "No Zone",
      "optionTooltip": "We remove points of contact that you have already reached out to within 5 days",
      "orderNow": "Order Now",
      "pick_sales_rep": "Pick a Sales Rep",
      "reassign": "Reassign",
      "recepientsName": "[Recipient's name]",
      "remove_contact_confirm": "Are you sure you want to remove '{name}' as a contact for this customer?",
      "search_error": "Unable to perform search",
      "select_contact": "Select a Contact",
      "service_zones_search_placeholder": "Search for Service Zones",
      "set_status_cleared": "{company} status cleared.",
      "set_status_success": "{company} status set to '{state}'",
      "show_archived_results": "Show Archived Search Results",
      "showing_num_results": "showing {num} results",
      "specify_state_order": "Specify the order of this state. Where 1 is the beginning of your sales funnel. For example a \"Cold Called\" status could be a 1.",
      "state_placeholder": "ie. Colorado or CO",
      "status_color": "Status Color",
      "thanks": "Thanks!",
      "tier_num": "Tier {num}",
      "toBeIncluded": "Brand Menu to be included",
      "transfer_data": "Transfer Data",
      "unarchive": "Un-Archive",
      "unarchive_customer_error": "Unable to set customer '{customer}' as active.",
      "unarchive_customer_success": "Customer '{customer}' set as active.",
      "unlink_contact_error": "Could not unlink contact from customer.",
      "unlink_contact_success": "{name} relationship removed.",
      "update_contact_date_error": "Could not update Next Contact Date",
      "update_contact_date_success": "Next Contact Date updated",
      "update_customer_status": "Update Customer Status",
      "update_sales_reps_error": "Could not update sales representatives.",
      "update_sales_reps_success": "Sales Representatives updated."
    },
    "deliveries": {
      "acquire_date": "Acquire Date",
      "acquire_type": "Acquire Type",
      "assigned_date": "Assigned Date",
      "assigned_from_date": "Assigned From Date",
      "assigned_to_date": "Assigned To Date",
      "created_from_date": "Created From Date",
      "created_to_date": "Created To Date",
      "delivery_info__acquire_date_from": "Acquired From",
      "delivery_info__acquire_date_to": "Acquired To",
      "edit_notes_modal_title": "Edit Note for Order {number}",
      "fetch_customers_error": "Could not fetch customers for filtering",
      "fetch_deliveries_error": "There was a problem fetching your deliveries.",
      "fetch_sellers_error": "Could not fetch sellers for filtering",
      "fetch_statuses_error": "Could not fetch statuses for filtering",
      "manifest_number": "Manifest Number",
      "sellers": "Sellers",
      "ship_date_modified": "Ship Date Modified After",
      "ship_from_date": "Ship From Date",
      "ship_to_date": "Ship To Date",
      "update_status_failure": "Could not set {attribute}.",
      "update_status_success": "{attribute} updated successfully."
    },
    "draft_orders": {
      "backordered_question": "Backordered?",
      "last_edited_by": "Last Edited By",
      "order_submit_error": "Error submitting Order {id}",
      "order_submit_success": "Successfully Submitted Order {id}",
      "owner": "Owner",
      "search_by_customers": "Search by Customers",
      "search_by_last_edited": "Search by Last Edited User",
      "submit_order": "Submit Order"
    },
    "expense_account": "Expense Account",
    "fetch_brands_error": "Could not fetch brands.",
    "fetch_company_data_error": "Failed to load company data.",
    "fetch_company_licenses_error": "Failed to retrieve company licenses.",
    "fetch_license_types_error": "Could not fetch license types.",
    "fetch_multi_facility_inv_error": "Failed to retrieve brand fulfillment multi facility company status",
    "fetch_product_lines_error": "Failed to load product lines.",
    "fetch_products_error": "Could not fetch products.",
    "fetch_quickbooks_items_error": "Failed to retrieve QuickBooks items.",
    "fetch_sales_reps_error": "Unable to fetch company staff members.",
    "fulfillment": {
      "all_checkboxes_required": "You must click all the checkboxes above before you can click the Fulfill Order Button",
      "attach_package": "Attach Package",
      "comment_meta_data": "By: {author} on {date}",
      "connect_product_to_metrc": "Connect Product to Metrc",
      "connected_metrc_item": "Connected Metrc Item",
      "fulfill_order": "Fulfill Order",
      "fulfill_order_error": "Error fulfilling Order {id} : {errors}",
      "fulfill_order_success": "Successfully fulfilled Order {id}",
      "load_fulfillment_queue_error": "Failed to load fulfillment queue.",
      "load_order_comments_error": "Failed to load order comments.",
      "load_sales_reps_error": "Failed to load sales representatives.",
      "load_service_zones_error": "Failed to load service zones.",
      "loading_comments": "Loading Comments",
      "metrc_connected_question": "Connected to Metrc?",
      "no_order_comments": "No comments for this order.",
      "packed_question": "Packed?",
      "remove_package_error": "Failed to remove package.",
      "ship_order": "Once marked as shipped, an order's status can only be reversed back to fulfilled by an Admin of your LeafLink account. Press OK to proceed or Cancel to go back.",
      "summary": "Below are <strong>Accepted</strong> orders ready to be fulfilled.",
      "unlinked_package": "Unlinked package {packageTag}"
    },
    "general_request_error": "There was a problem with your request. Please try again or contact support.",
    "income_account": "Income Account",
    "inventory": {
      "multipleInventoryItemsRedirect": "Products with multiple inventory items can be updated from the Inventory page",
      "reconcile_inventory": "Reconcile Inventory",
      "status_update_warning": "Updating the product status on a parent product will now update the status on all of the product's varieties. You are still able to change the product status of each variety individually.",
      "strains": {
        "add_strain": "Add Strain",
        "empty_strains": "You have not created any custom strains.",
        "update_strain": "Update Strain"
      }
    },
    "invoice_pdf": "Invoice PDF",
    "last_payment_date": "Last Payment Date",
    "load_company_error": "Failed to load company.",
    "load_draft_orders_error": "Failed to load list of draft orders.",
    "load_line_items_error": "Failed to load line items.",
    "load_packages_error": "Failed to load packages.",
    "load_products_error": "Failed to load products.",
    "manage_territories": {
      "create_territories": "Create Territories",
      "delete_territory": "Delete Territory",
      "delete_territory_confirm": "Are you sure you want to delete this territory?",
      "delete_territory_error": "Failed to delete territory.",
      "delete_territory_success": "Successfully deleted territory.",
      "fetch_company_territories_error": "Failed to retrieve current territories for company.",
      "no_territories_exist": "You haven't created any territories.",
      "shipping_price": "Shipping Price",
      "update_all_territories_error": "Failed to update all territories.",
      "update_all_territories_success": "Territories updated.",
      "update_territories_error": "Failed to update territories."
    },
    "manual_orders": {
      "create_order_error": "Could not create your order.",
      "discount_decimal_error": "Discounts can only have up to two decimal places.",
      "discount_minimum_error": "Discount values must be greater than 0.",
      "discount_range_error": "Percent discounts must be between 0 and 100.",
      "fetch_order_error": "Could not fetch order.",
      "fetch_remaining_products_error": "Could not fetch remaining products.",
      "insufficient_inventory_error": "Not enough inventory available for purchase. If you are trying to add a product on backorder, please create a new order with the item and mark it for backorder.",
      "quantity_fraction_error": "This product does not allow fractional quantities",
      "quantity_insufficient_error": "Not enough inventory available",
      "quantity_minimum_error": "Must be greater than 0",
      "sale_price_limit_error": "Sale price must be less than wholesale price",
      "submit_order_error": "Could not submit your order."
    },
    "markpaid_input_helper": "You can enter negative numbers for credits, refunds or bounced payments.",
    "med": "Med",
    "metrc_item": "Metrc Item",
    "metrc_package": "Metrc Package",
    "new_package_tag": "New Package Tag",
    "not_connected": "Not Connected",
    "order_entered_by_seller": "This order was entered by the seller on the buyer's behalf.",
    "order_has_existing_balance": "This order has an existing balance of {balance}.",
    "order_has_special_requests": "This order has special requests.",
    "order_id": "Order ID",
    "order_invoice": {
      "attach_documents": "Attach Documents",
      "back_to_order_deliveries": "Back to Order Deliveries",
      "back_to_orders_received": "Back to Orders Received",
      "back_to_orders_sent": "Back to Orders Sent",
      "back_to_shipping_queue": "Back to Shipping Queue",
      "batch_id": "Batch ID",
      "cancel_order_confirm": "Are you sure you want to cancel this order?",
      "cancelling_order": "Cancelling Order",
      "change_order_status": "Change Order Status",
      "click_to_resolve": "Click here to resolve.",
      "collab_order_created_warning": "This order is a draft made by the seller. It won't be fulfilled until you approve it. <a href='../summary'>Click here</a> to go to the newer version of this page to approve the order.",
      "contact_buyer": "Contact Buyer",
      "contact_seller": "Contact Seller",
      "createReturn": "Create Return",
      "create_invoice_success": "Invoice created.",
      "credits": "Credits",
      "delete_draft": "Delete Draft",
      "delete_draft_order_confirm": "Are you sure you want to delete this draft order? This action is permanent and removes the order, line items and any messages, notes, or details associated with it.",
      "deleting_order": "Deleting Order",
      "directions": "Directions",
      "draft_state_inventory_warning": "Heads up! Orders in the <strong>Draft</strong> state don't modify inventory or available quantities!",
      "edit_batch": "Edit Batch",
      "edit_batch_error": "Failed to change Batch ID.",
      "edit_batch_success": "Successfully changed Batch ID.",
      "edit_delivery_provider_details": "Edit Trusted Delivery Provider Details",
      "edit_order_confirm_title": "Editing a {state} Order",
      "edit_order_in_state_confirm": "You are about to edit an order in the '{state}' state. <br/><br/><strong>Changing inventory amounts for Orders in the '{state}' state will not automatically update your Inventory or Available Quantities to reflect these changes and must be done manually.</strong><br/><br/>To ensure inventory is updated, reverse the status of the order back to the Accepted state and make any edits.<br/><br/>Are you sure you want to continue?",
      "edit_sales_representatives": "Edit Sales Representatives",
      "edit_shipping_details": "Edit Shipping Details",
      "email_invoice": "Email Invoice",
      "excise_tax_disclaimer": "Unless otherwise noted, Excise tax is due on delivery.",
      "fetch_order_error": "Failed to load order.",
      "fetch_quickbooks_customers_error": "Failed to retrieve QuickBooks customers.",
      "hide_batch_id": "Hide Batch ID on Invoice",
      "how_to_edit_per_order": "You can change this per order by selecting Edit Order in the Actions menu at the top of the page.",
      "internal_comments": "Internal Comments",
      "internal_order_notes": "Internal Order Notes",
      "item_on_backorder": "This item is on backorder!",
      "legacy_invoice": "Legacy Invoice",
      "load_batches_error": "Failed to load batches for item.",
      "mark_as_paid": "Mark As Paid",
      "messages": "@:common.messages",
      "order_delivery_preferences": "Order Delivery Preferences",
      "product_list": "Product List",
      "push_invoice_to_service": "Push Invoice to {name}",
      "quickbooks_token_expired": "Your QuickBooks token expired.<br/>Click here to resolve.",
      "reject_order_confirm": "Are you sure you want to reject this order?",
      "rejecting_order": "Rejecting Order",
      "repush_invoice_to_service": "Re-Push Invoice to {name}",
      "returned": "Returned",
      "select_batch_id": "Select Batch ID",
      "shipping_charge": "Shipping Charge",
      "shipping_details": "Shipping Details",
      "split_attach_packages": "Split / Attach Packages",
      "submitting_order": "Submitting Order",
      "submitting_order_confirm_li_1": "The original orders being combined will be marked <strong>Combined</strong>",
      "submitting_order_confirm_li_2": "Your vendors <strong>will not</strong> receive an order status change email",
      "submitting_order_confirm_li_3": "In cases where product prices differed between orders, multiple line items will be created",
      "submitting_order_confirm_li_4": "If the discounts on each order are different types or different % values they will be removed from the new order",
      "submitting_order_confirm_li_5": "Credits applied to orders that were combined have been reassigned to this order",
      "submitting_order_confirm_note": "<strong>Please note</strong>, upon submission the following actions will occur",
      "tax_value_and_details": "Tax is {taxRate}. This includes:<br /><br /> {orderTaxes}<br /> This excludes ancillary items and whole order discounts. {sellerMsg}<br /><br /> <strong>Note for CA Sellers:</strong> The CDTFA specifies all discounts during an arm's length transaction must be added back into the taxable price for all retailers. You can read more CDTFA information about proper excise tax calculation <a href=\"http://www.cdtfa.ca.gov/industry/cannabis.htm#Facts\" target=\"_blank\">here</a>.",
      "total_price": "Total Price",
      "total_weight": "Total Weight",
      "transfers": "Transfers",
      "unit_price": "Unit Price",
      "update_order_id_error": "Could not update Order ID.",
      "usable_mmj": "Usable MMJ",
      "vendor_disclaimer": "Vendor Disclaimer",
      "view_order_log": "View Order Log"
    },
    "order_made_through_leaflink": "This order was made through LeafLink.",
    "order_notes": "Order Notes",
    "order_payments": {
      "add_payment": "Add Payment",
      "amount_paid_input_helper": "Enter a negative number to cancel out previously added payments, add a refund or note a bounced payment. Payments cannot be deleted.",
      "enter_payment_amount_error": "Please enter a payment amount.",
      "enter_payment_date_error": "Enter a valid payment date",
      "mark_order_paid_warning": "This will mark the order as Paid.",
      "no_payments_submitted": "No payments submitted for order {number}",
      "order_payment_history": "Order Payment History",
      "payment_functionality_off": "You do not have LeafLink's payment functionality turned on. Contact support{'@'}leaflink.com to get started!",
      "reason_placeholder": "Enter reason",
      "remaining_balance": "Remaining Balance",
      "save_payment_success": "Payment saved!",
      "submitted_by_name_date": "Submitted by: {name} on {date}"
    },
    "order_used_llf_payment": "This retailer requested LeafLink Financial as payment",
    "order_was_paid": "This order was paid.",
    "orders": {
      "loading_line_items": "Loading Line Items",
      "manifest_id": "Manifest ID",
      "order_balance": "Order Balance",
      "order_delivery_preferences": "Order Delivery Preferences",
      "order_paid_in_full": "This Order was paid in full.",
      "search_by_name": "Search by Name or SKU"
    },
    "orders_received": {
      "all_orders": "All Orders",
      "click_to_map": "Click here to map them.",
      "combined_order": "Combined Order",
      "confirm_push_orders_to_quickbooks": "Are you sure you want to push the following orders to QuickBooks?",
      "connected_to_quickbooks_question": "Connected to QuickBooks?",
      "create_an_order": "Create an Order",
      "customer_not_mapped_quickbooks": "The customer, {name}, on this order has not yet been mapped to a QuickBooks customer. Please select the QuickBooks customer you\"d like to map to.",
      "customer_search_error": "Error while searching for customers!",
      "delivered_by": "Delivered By",
      "fetch_order_data_error": "Could not get order {number} data.",
      "fetch_orders_error": "Could not fetch orders.",
      "fetch_sales_reps_for_filtering_error": "Could not fetch sales representatives for filtering",
      "fetch_service_zones_error": "Could not fetch service zones for filtering",
      "from_date": "From Date",
      "invoice_created": "Invoice created",
      "last_seven_days": "Last 7 Days",
      "loading_orders": "Loading Orders",
      "lockOrder": "Lock order",
      "lockOrderError": "The order {number} couldn't be locked. Please try again.",
      "lockOrderSuccess": "The order {number} was successfully locked.",
      "manual": "Seller Generated",
      "no_results_found": "No results found, please check your spelling or revise your search.",
      "order_already_target_status_error": "Order {id} already marked {status} - please refresh this page before trying again.",
      "order_from_delinquent_customer": "This order is from a Customer who you have marked as delinquent.",
      "order_not_pushed_to_quickbooks": "This order has not been pushed to QuickBooks.",
      "order_pushed_to_quickbooks": "This order was pushed to QuickBooks.",
      "orders_with_unmapped_products_not_pushed": "Orders with unmapped products or customers will not be pushed to QuickBooks. Please map products and customers before pushing to QuickBooks.",
      "organic": "Buyer Generated",
      "push_invoices_to_quickbooks": "Push Invoices to QuickBooks",
      "push_order_error": "Could not push order {number} : {response}",
      "push_order_success": "Successfully pushed order: {number}",
      "push_orders_to_quickbooks": "Push Orders to QuickBooks",
      "push_to_quickbooks": "Push to QuickBooks",
      "reject_email": "Do not send email notification to buyer",
      "reject_order": "Reject Order",
      "reject_order_header": "Select a reason for rejecting this order and enter any additional notes. This information will be visible to buyers on the Order Summary page. Note that rejecting an order is NOT reversible.",
      "reject_reason": "Reason for Rejections",
      "search_by_customer": "Search by Customer",
      "sum_on_num_orders": "<strong class=\"text-underline\">${sum}</strong> on <strong>{numOrders}</strong> Orders",
      "title": "Orders Received",
      "to_date": "To Date",
      "transition_order_status_error": "Could not transition order {id}",
      "type_minimum_to_search": "Type 3 or more characters to search.",
      "unlockOrder": "Unlock order",
      "unlockOrderError": "The order {number} couldn't be unlocked. Please try again.",
      "unlockOrderSuccess": "The order {number} was successfully unlocked.",
      "unmapped_customer": "Unmapped Customer",
      "who_is_order_for": "Which customer is this order for?"
    },
    "orders_sent": {
      "company_has_temp_licenses": "This company has 2018 TEMP licenses.",
      "confirm_order_delivery_date": "Confirm Order Delivery Date",
      "delivery_confirmation_date_format_error": "Delivery confirmation date must be in YYYY-MM-DD format.",
      "delivery_date_label": "When was this order received?",
      "markOrderAsPaid": "Mark order as paid",
      "markOrderAsPaidObs": "This is for your record only. It may not match the seller's order status.",
      "no_orders": "No Orders",
      "order_has_been_received": "This order has been received.",
      "order_information_saved": "Order information saved.",
      "order_not_yet_accepted": "This order has not been accepted by the seller yet.",
      "order_not_yet_received": "This order has not yet been received.",
      "order_under_company_minimum": "This order is under your company's order minimum of {minimum}",
      "received_question": "Received?",
      "remove_delivery_confirmation_question": "Remove Delivery Confirmation?",
      "reorder": "Reorder"
    },
    "payment_submit_error": "There was a problem submitting your payment.",
    "payment_submit_success": "Payment submitted",
    "products": {
      "archive_product_confirm": "Are you sure you want to mark this product as Archived?",
      "available_qty": "Available: {qty}",
      "change_log": "Change Log",
      "clone": "Clone",
      "company_products": "{companyName} Products",
      "connect_metrc_items": "Connect Metrc Items",
      "create_product_success": "'{name}' saved to inventory.",
      "current_inventory": "Current Inventory",
      "dealPrice": "Deal Price",
      "dealsPriceDisabled": "Edit the product and add a Deals Price to feature this product on the {campaignLabel} campaign",
      "dealsPriceEnabled": "This product will be featured on the {campaignLabel} campaign",
      "delete_product_image_error": "Error deleting image.",
      "delete_product_spec_confirm": "Are you sure you want to delete this product specification?",
      "delete_product_spec_error": "Error deleting product specification.",
      "delete_product_spec_success": "Removed '{product}' specification.",
      "delete_variety_error": "Error Deleting Variety",
      "featured_on_deals": "Featured on Deals",
      "fetch_children_error": "Could not fetch children!",
      "fetch_licenses_error": "Could not fetch licenses.",
      "fetch_listing_states_error": "Could not fetch listing states.",
      "fetch_product_categories_error": "Could not fetch product categories.",
      "fetch_product_templates_error": "Could not fetch product templates.",
      "general_submission_error": "There were errors with your submission. Please check the form and try again.",
      "in_cases": "in cases",
      "inherited_inventory": "Inherited Inventory",
      "inventory_sold_in_bulk": "{unit_multiplier}x {unit_denomination} {unit_of_measure} per {sell_in_unit_of_measure}",
      "item_available_at_date": "Item available at {date}",
      "item_currently_featured": "This item is currently featured.",
      "item_dropped_at_time": "Item dropped at {time}",
      "item_dropped_date": "Item dropped {date}",
      "leaflink_deals": "LeafLink Deals",
      "max_deals_reached": "You have already selected {productMax} products from this brand to be promoted on the {campaignLabel} campaign.",
      "metrcPackagesRedirect": "Packages are now in Reconcile Inventory",
      "metrc_connected_question": "Metrc Connected?",
      "metrc_packages": "Metrc Packages",
      "min_deals_discount": "Sale price must be at least {minDiscount}% off the wholesale price to be featured in the {campaignLabel} campaign.",
      "missingUnitInformation": "Missing unit information",
      "missingUnitInformationTooltip": "Filter by products that are missing information about what is in a unit",
      "no_batch_associated": "No batch associated",
      "no_custom_strains_exist": "You have not created any custom strains.",
      "no_products_found": "No Products Found",
      "num_product_options": "{count} product options",
      "num_skus_found": "{count} SKUs found",
      "performance": "Performance",
      "product_family_has_various_states": "This product family has various states.",
      "product_has_no_images": "This product has no images. Buyers will see the brand logo on shopping pages.",
      "proposed_inventory": "Proposed Inventory",
      "reserved_qty": "{qty} reserved",
      "restock": "Restock",
      "restock_inventory_error": "Error while restocking '{name}'",
      "restock_inventory_success": "Updated inventory levels for '{name}'",
      "retail_price_msrp": "Retail Price (MSRP)",
      "salePrice": "Sale Price",
      "search_products_by_fields": "Search Products by Name, SKU, Status, Category and License Type",
      "select_items_to_attach": "Select Items to Attach",
      "time_until_date": "Time until {date}",
      "unit_of_measure_no_inherited_inventory_support": "This current unit of measure will not work with inherited inventory.",
      "update_inventory_error": "Could not update product inventory",
      "update_inventory_success": "Updated inventory levels",
      "update_listing_state_error": "Error updating listing state for '{name}'",
      "update_listing_state_success": "'{name}' set to {state}",
      "update_pricing_error": "Error updating '{name}'",
      "update_pricing_success": "Updated pricing data for '{name}'",
      "update_product_image_success": "'{name}' successfully updated.",
      "update_product_state_error": "Could not update product listing state. {error} ",
      "update_product_state_general_error": "Could not update product listing state",
      "update_product_state_success": "Updated product listing state",
      "updated_date": "Updated: {date}",
      "upload_product_image_error": "Error saving image. Please check the image size (2MB max).",
      "upload_product_image_success": "Image for '{name}' successfully uploaded.",
      "wholesale_price": "Wholesale Price"
    },
    "products_not_mapped_to_quickbooks": "The following LeafLink products have not yet been mapped to a QuickBooks product. Please select the QuickBooks product you'd like to map to.",
    "push_order_to_quickbooks": "Push Order to QuickBooks",
    "push_to_name": "Push to {name}",
    "repush_to_name": "Re-Push to {name}",
    "s2s": {
      "accepted_package_count": "Accepted Package Count",
      "active": "Active",
      "actual_departure": "Actual Departure",
      "adjustment_quantity": "Adjustment Quantity",
      "administration_method": "Administration Method",
      "all_fields_required": "All fields are required.",
      "any_testing_state": "Any Testing State",
      "associate_transfer_error": "Failed to associate transfer.",
      "attach_package_error": "Failed to attach package.",
      "attach_package_success": "Package attached to order.",
      "categories": "Categories",
      "category_type": "Category Type",
      "create_package_success": "Package successfully created.",
      "created": "Created",
      "date_created": "Date Created",
      "delivery_information": "Delivery Information",
      "delivery_package_count": "Delivery Package Count",
      "display_on_invoice": "Display on Invoice",
      "enter_formatted_date_error": "Please enter a date in 'DD-MM-YYYY' format.",
      "estimated_arrival_time": "Est Arrival Time",
      "estimated_departure": "Est Departure",
      "export_available_tags_from_metrc_dashboard": "1. Export \"Available tags\" from your Metrc dashboard",
      "facility": "Facility",
      "fetch_adjustment_reasons_error": "Failed to retrieve adjustment reasons.",
      "fetch_attached_transfers_error": "Failed to retrieve attached transfers for this order.",
      "fetch_items_error": "Failed to retrieve items.",
      "fetch_order_transfers_error": "Failed to retrieve transfers for this order.",
      "fetch_transfer_associated_deliveries_error": "Failed to retrieve deliveries associated with this transfer.",
      "find_transfer_in_metrc_error": "Can't find transfer in Metrc. Please contact support.",
      "finish_package_error": "Failed to finish package.",
      "finish_package_success": "Successfully finished this package.",
      "finished_date": "Finished Date",
      "inactive": "Inactive",
      "item_name": "Item Name",
      "lab_testing_state": "Lab Testing State",
      "lab_tests": "Lab Tests",
      "last_modified": "Last Modified",
      "last_month": "Last month",
      "last_week": "Last week",
      "loadLocationsError": "Failed to load locations.",
      "load_dashboard_packages_error": "Failed to load packages to populate the dashboard.",
      "load_delivery_packages_error": "f packages for this delivery.",
      "load_item_packages_error": "Failed to load packages for item.",
      "load_items_error": "Failed to load items.",
      "load_packages_error": "Failed to load packages.",
      "load_units_of_measure_error": "Failed to load units of measure.",
      "manifest": "Manifest",
      "manifest_number": "Manifest No.",
      "metrcDestinationLocation": "Metrc Destination Location",
      "metrc_dashboard": "Metrc Dashboard",
      "metrc_destination_item": "Metrc Destination Item",
      "metrc_item_name": "Metrc Item Name",
      "metrc_items": "Metrc Items",
      "new_amount": "New Amount",
      "new_package_amount": "New Package Amount",
      "new_package_quantity": "New Package Quantity",
      "new_source_package_amount": "New Source Package Amount",
      "new_value": "New Value",
      "no_associated_products": "No associated products found.",
      "no_elements_found": "Oops! No elements found. Consider changing the search query.",
      "no_packages_found": "No packages found.",
      "num_packages": "{num} Packages",
      "num_sign_packages": "# Packages",
      "num_total_packages_and_remaining": "{total} Total Packages, {remaining} remaining",
      "package": "Package",
      "package_action_confirm": "Are you sure you want to {action} this package?",
      "package_date": "Package Date",
      "packaged": "Packaged",
      "packaged_date": "Packaged Date",
      "packages": "Packages",
      "product_and_metrc_item_association_enables": "Associating LeafLink products with this Metrc item will allow you to: View the current Metrc Inventory levels when viewing the LeafLink product and select a package to associate with a line item on your LeafLink order",
      "received_time": "Received Time",
      "recipient": "Recipient",
      "refresh_metrc_data_error": "Failed to refresh Metrc data.",
      "refreshed_on": "Refreshed On",
      "remove_transfer_error": "Failed to remove transfer.",
      "remove_transfer_success": "Successfully removed transfer from LeafLink.",
      "search_by_label_or_name": "Search by product label or item name",
      "search_for_metrc_items_by": "Search for Metrc items by name, category or strain",
      "select_adjustment_error": "Please select an adjustment reason, package and adjustment date.",
      "select_date_range_error": "Please select a valid date range.",
      "select_package": "Select Package",
      "select_products": "Select Products",
      "select_timeframe_to_sync_metrc": "Select timeframe to sync Metrc {resourceName}",
      "select_timeframe_to_sync_metrc_info": "Select timeframe to sync Metrc information",
      "serving_size": "Serving Size",
      "source_package": "Source Package",
      "split_package": "Split Package",
      "split_package_error": "Failed to split package.",
      "split_package_success": "Successfully split package.",
      "submit_to_metrc": "Submit to Metrc",
      "supply_duration_days": "Supply Duration Days",
      "syncing_metrc_information": "Syncing Metrc information",
      "testing_state": "Testing State",
      "total_quantity": "Total Quantity",
      "unfinish_package_error": "Failed to unfinish package.",
      "unfinish_package_success": "Successfully unfinished this package.",
      "unit_cbd_content": "Unit CBD Content",
      "unit_cbd_content_unit_of_measure": "Unit CBD Content unit of measure",
      "unit_cbd_percentage": "Unit CBD Percentage",
      "unit_thc_content": "Unit THC Content",
      "unit_thc_content_unit_of_measure": "Unit THC Content unit of measure",
      "unit_thc_percentage": "Unit THC Percentage",
      "unit_volume": "Unit Volume",
      "unit_weight": "Unit Weight",
      "unit_weight_unit_of_measure": "Unit Weight Unit of Measure",
      "update_metrc_item_error": "Could not update metrc item.",
      "update_metrc_item_success": "Updated item.",
      "update_product_error": "Failed to update product.",
      "update_product_success": "Product updated.",
      "update_products_error": "Failed to update all products",
      "update_products_success": "Products updated.",
      "updating_metrc_data_error": "Failed to update METRC data.",
      "updating_metrc_data_warning": "Updating your METRC data, please check for updates in 10 minutes!",
      "use_code_scanner_tip": "Tip: You can use your Code CR950/CR2600 scanner to input tag numbers."
    },
    "save_shipment_date_error": "Error saving shipment date",
    "save_shipment_date_success": "Shipment date saved",
    "service_zones": "Service Zones",
    "shipping_manifest": {
      "delivery_provider": "Delivery Provider",
      "description": "You are about to Print the Shipping Manifest for Invoice #{orderId}. You may include the Driver's Information below or simply Skip to Print.",
      "driver": "Driver",
      "driver_phone": "Driver's Phone",
      "license_plate": "License Plate",
      "notes": "Shipping Notes",
      "title": "Shipping Manifest",
      "vehicle_make": "Vehicle Make",
      "vehicle_model": "Vehicle Model"
    },
    "source": "Source",
    "submit_payment": "Submit payment",
    "territories": {
      "add_new_territory": "Add New Territory",
      "create_territory_error": "Failed to create territory.",
      "create_territory_success": "Successfully created territory.",
      "delete_territory": "Delete Territory",
      "delete_territory_confirm": "Are you sure you want to delete this territory?",
      "delete_territory_error": "Failed to delete territory.",
      "delete_territory_success": "Successfully deleted territory.",
      "enter_location": "Enter location",
      "fetch_company_territories_error": "Failed to retrieve current territories for company.",
      "fetch_state_regions_error": "Failed to retrieve regions for state.",
      "save_territory": "Save Territory",
      "update_territory_error": "Failed to edit territory.",
      "update_territory_success": "Successfully updated territory."
    },
    "update_customer_success": "Successfully updated customer.",
    "update_line_item_error": "Failed to update line item.",
    "update_line_item_success": "Line Item updated!",
    "update_product_success": "Successfully updated product.",
    "use_old_create_order": "Prefer the old Create Order page?",
    "view_order": "View Order"
  },
  "ll": {
    "allStatuses": "All Statuses",
    "date": {
      "months": {
        "april": "April",
        "august": "August",
        "december": "December",
        "february": "February",
        "january": "January",
        "july": "July",
        "june": "June",
        "march": "March",
        "may": "May",
        "november": "November",
        "october": "October",
        "september": "September"
      },
      "next_month": "Next Month",
      "previous_month": "Previous Month",
      "weekdays": {
        "friday": "Friday",
        "monday": "Monday",
        "saturday": "Saturday",
        "sunday": "Sunday",
        "thursday": "Thursday",
        "tuesday": "Tuesday",
        "wednesday": "Wednesday"
      },
      "weekdays_abbreviated": {
        "friday": "Fri",
        "monday": "Mon",
        "saturday": "Sat",
        "sunday": "Sun",
        "thursday": "Thu",
        "tuesday": "Tue",
        "wednesday": "Wed"
      }
    },
    "file_upload": {
      "csvImport": "CSV Import",
      "csv_title_inventory": "This CSV import will only update product inventory levels.",
      "drag_drop_file_here": "Drag and drop your file here",
      "errors": {
        "csv_title": "There was an error importing your CSV.",
        "duplicate_product": "Duplicate entry: {sku}",
        "incorrect_file_type": "Please drop a file with type: {fileTypes}",
        "invalid_csv_headers": "Invalid CSV Header: file must include only {headers}",
        "invalid_product_total": "Invalid value in Total: value for {sku} must be a positive number",
        "is_not_unlimited": "Invalid value in Total: A product's inventory management setting cannot be changed to \"unlimited\" with this import. Please set Total value for {sku}",
        "is_unlimited": "Invalid value in Total: A product's inventory management setting cannot be changed from \"unlimited\" with this import. Total must remain \"unlimited\" for {sku}",
        "missing_column": "Row {rowNum} has {columnNum} columns. Every row must have {expectedColumnNum} columns | Row {rowNum} only has {columnNum} column. Every row must have {expectedColumnNum} columns | Row {rowNum} only has {columnNum} columns. Every row must have {expectedColumnNum} columns",
        "missing_header": "Missing header: {header}",
        "no_sku": "SKU in row {rowNum} may not be blank",
        "sku_does_not_exist": "SKU does not exist in product list: {sku}"
      },
      "exportLabels": {
        "all": {
          "item": "All items",
          "product": "All products",
          "task": "All tasks",
          "zone": "All zip codes"
        },
        "matchingSearchAndFilters": {
          "item": "Items matching your search and filters | {num} item matching your search and filters | {num} items matching your search and filters",
          "product": "Products matching your search and filters | {num} product matching your search and filters | {num} products matching your search and filters",
          "task": "Tasks matching your search and filters | {num} tasks matching your search and filters",
          "zone": "1 zip code matching your search | {num} zip codes matching your search"
        }
      },
      "export_csv": "Export CSV",
      "import_csv": "Import CSV",
      "in_csv": {
        "item": "<strong>0 items</strong> in CSV | <strong>{num} item</strong> in CSV | <strong>{num} items</strong> in CSV",
        "product": "<strong>0 products</strong> in CSV | <strong>{num} product</strong> in CSV | <strong>{num} products</strong> in CSV",
        "zone": "0 zones in CSV | {num} zone in CSV | {num} zones in CSV"
      },
      "try_again": "Try Again",
      "uploadCsv": "Upload CSV",
      "upload_file": "Upload File",
      "willBeCreated": {
        "zone": "0 zones will be created | {num} zone will be created | {num} zones will be created"
      },
      "will_be_updated": {
        "item": "<strong>0 items</strong> will be updated | <strong>{num} item</strong> will be updated | <strong>{num} items</strong> will be updated",
        "product": "<strong>0 products</strong> will be updated | <strong>{num} product</strong> will be updated | <strong>{num} products</strong> will be updated",
        "zone": "0 zones will be updated | {num} zone will be updated | {num} zones will be updated"
      }
    },
    "imageGallery": {
      "maxFileSize": "Image {name} exceeds the maximum ({max}MB) file size allowed.",
      "minImageSize": "Image {name} does not meet the recommended dimensions of {width} x {height}px and may result in loss of quality.",
      "multipleFileUploadSafari": "Multiple image uploads are not supported in this browser."
    },
    "list_view": {
      "calculating": "Calculating results...",
      "totalResults": "Showing {num} of {total} results"
    },
    "select": {
      "placeholder": "Select option"
    },
    "select_panels": {
      "applied_items": "Applied {items}",
      "available_items": "Filter {items}"
    },
    "sorts": {
      "amountAsc": "Amount (Low to High)",
      "amountDesc": "Amount (High to Low)",
      "assignedDateAsc": "Assigned Date (Old to New)",
      "assignedDateDesc": "Assigned Date (New to Old)",
      "availableAsc": "Available (Low to High)",
      "availableDesc": "Available (High to Low)",
      "balanceAsc": "Balance (Low to High)",
      "balanceDesc": "Balance (High to Low)",
      "brandMinimumAsc": "Brand Minimum (Low to High)",
      "brandMinimumDesc": "Brand Minimum (High to Low)",
      "brandNameAsc": "Brand Name (A-Z)",
      "brandNameDesc": "Brand Name (Z-A)",
      "buyerAsc": "Buyer (A-Z)",
      "buyerDesc": "Buyer (Z-A)",
      "categoryNameAsc": "Category (A-Z)",
      "categoryNameDesc": "Category (Z-A)",
      "classificationAsc": "Classification (A-Z)",
      "classificationDesc": "Classification (Z-A)",
      "createdDateAsc": "Created Date (Old to New)",
      "createdDateDesc": "Created Date (New to Old)",
      "creditAsc": "Credit (Low to High)",
      "creditDesc": "Credit (High to Low)",
      "customerAsc": "Customer (A-Z)",
      "customerDesc": "Customer (Z-A)",
      "customerStatusAsc": "Customer Status (A-Z)",
      "customerStatusDesc": "Customer Status (Z-A)",
      "dailySaleAsc": "Daily Sale (Low to High)",
      "dailySaleDesc": "Daily Sale (High to Low)",
      "dateAsc": "Date (Old to New)",
      "dateDesc": "Date (New to Old)",
      "daysLeftOnHandAsc": "Days Left on Hand (Low to High)",
      "daysLeftOnHandDesc": "Days Left on Hand (High to Low)",
      "deliveryDateAsc": "Delivery Date (Old to New)",
      "deliveryDateDesc": "Delivery Date (New to Old)",
      "discountAsc": "Discount (Low to High)",
      "discountDesc": "Discount (High to Low)",
      "dueDateAsc": "Due Date (Old to New)",
      "dueDateDesc": "Due Date (New to Old)",
      "estimatedReceivingDateAsc": "Estimated Receiving Date (Old to New)",
      "estimatedReceivingDateDesc": "Estimated Receiving Date (New to Old)",
      "etosAsc": "ETOS (Low to High)",
      "etosDesc": "ETOS (High to Low)",
      "expectedShipDateAsc": "Expected Ship Date (Old to New)",
      "expectedShipDateDesc": "Expected Ship Date (New to Old)",
      "expirationDateAsc": "Expiration Date (Old to New)",
      "expirationDateDesc": "Expiration Date (New to Old)",
      "firstOrderDateAsc": "First Order Date (Old to New)",
      "firstOrderDateDesc": "First Order Date (New to Old)",
      "inventoryAsc": "Inventory (Low to High)",
      "inventoryDesc": "Inventory (High to Low)",
      "invoiceDateAsc": "Invoice Date (Old to New)",
      "invoiceDateDesc": "Invoice Date (New to Old)",
      "invoiceNumberAsc": "Invoice Number (Low to High)",
      "invoiceNumberDesc": "Invoice Number (High to Low)",
      "invoiceTotalAsc": "Invoice Total (Low to High)",
      "invoiceTotalDesc": "Invoice Total (High to Low)",
      "itemNameAsc": "Item Name (A-Z)",
      "itemNameDesc": "Item Name (Z-A)",
      "itemsAsc": "Items (Low to High)",
      "itemsDesc": "Items (High to Low)",
      "lastEditedByAsc": "Last Edited By (Old to New)",
      "lastEditedByDesc": "Last Edited By (New to Old)",
      "lastOrderDateAsc": "Last Order Date (Old to New)",
      "lastOrderDateDesc": "Last Order Date (New to Old)",
      "latestRecipeDateAsc": "Latest Receipt Date (Old to New)",
      "latestRecipeDateDesc": "Latest Receipt Date (New to Old)",
      "leaflinkCustomerAsc": "LeafLink Customer (A-Z)",
      "leaflinkCustomerDesc": "LeafLink Customer (Z-A)",
      "licenseNumberAsc": "License Number (A-Z)",
      "licenseNumberDesc": "License Number (Z-A)",
      "licenseTypeAsc": "License Type (A-Z)",
      "licenseTypeDesc": "License Type (Z-A)",
      "menuUpdateAsc": "Menu Update (Old to New)",
      "menuUpdateDesc": "Menu Update (New to Old)",
      "nameAsc": "Name (A-Z)",
      "nameDesc": "Name (Z-A)",
      "nextContactDateAsc": "Next Contact Date (Old to New)",
      "nextContactDateDesc": "Next Contact Date (New to Old)",
      "oldestReceiptDateAsc": "Oldest Receipt Date (Old to New)",
      "oldestReceiptDateDesc": "Oldest Receipt Date (New to Old)",
      "orderAsc": "Order (A-Z)",
      "orderDateAsc": "Order Date (Old to New)",
      "orderDateDesc": "Order Date (New to Old)",
      "orderDesc": "Order (Z-A)",
      "orderedDateAsc": "Ordered Date (Old to New)",
      "orderedDateDesc": "Ordered Date (New to Old)",
      "packageLabelAsc": "Package Label (0-Z)",
      "packageLabelDesc": "Package Label (Z-0)",
      "paymentStatusAsc": "Payment Status (A-Z)",
      "paymentStatusDesc": "Payment Status (Z-A)",
      "pickupDateAsc": "Pickup Date (Old to New)",
      "pickupDateDesc": "Pickup Date (New to Old)",
      "priceAsc": "Price (Low to High)",
      "priceDesc": "Price (High to Low)",
      "productCountDesc": "Product Count (High to Low)",
      "productNameAsc": "Product Name (A-Z)",
      "productNameDesc": "Product Name (Z-A)",
      "quantityAsc": "Quantity (Low to High)",
      "quantityDesc": "Quantity (High to Low)",
      "receivedDateAsc": "Received Date (Old to New)",
      "receivedDateDesc": "Received Date (New to Old)",
      "restockAsc": "Restock (Low to High)",
      "restockDesc": "Restock (High to Low)",
      "retailerPriceAsc": "Retail Price (Low to High)",
      "retailerPriceDesc": "Retail Price (High to Low)",
      "runRateAsc": "Run Rate (Low to High)",
      "runRateDesc": "Run Rate (High to Low)",
      "sellerAsc": "Seller (A-Z)",
      "sellerDesc": "Seller (Z-A)",
      "shipDateAsc": "Ship date (Old to New)",
      "shipDateDesc": "Ship date (New to Old)",
      "skuAsc": "SKU (A-Z)",
      "skuDesc": "SKU (Z-A)",
      "soldByAsc": "Sold By (A-Z)",
      "soldByDesc": "Sold By (Z-A)",
      "statusAsc": "Status (A-Z)",
      "statusDesc": "Status (Z-A)",
      "submittedAsc": "Submitted Date (Old to New)",
      "submittedDesc": "Submitted Date (New to Old)",
      "totalAsc": "Total (Lowest to Highest)",
      "totalDesc": "Total (Highest to Lowest)",
      "totalOrderAmountAsc": "Total Order Amount (Low to High)",
      "totalOrderAmountDesc": "Total Order Amount (High to Low)",
      "unitsAsc": "Units (Low to High)",
      "unitsDesc": "Units (High to Low)",
      "upcomingDeliveryAsc": "Upcoming Delivery (Old to New)",
      "upcomingDeliveryDesc": "Upcoming Delivery (New to Old)",
      "upcomingOrderAsc": "Upcoming Order (Old to New)",
      "upcomingOrderDesc": "Upcoming Order (New to Old)",
      "uploadedDateAsc": "Uploaded Date (Old to New)",
      "uploadedDateDesc": "Uploaded Date (New to Old)",
      "valueAsc": "Value (A-Z)",
      "valueDesc": "Value (Z-A)",
      "wholesalePriceAsc": "Wholesale Price (Low to High)",
      "wholesalePriceDesc": "Wholesale Price (High to Low)"
    }
  },
  "messages": {
    "backToAllMessages": "Back to all Messages",
    "createNewMessage": "Create New Message",
    "filters": {
      "chatStatus": "Chat Status"
    },
    "from": "From: {senderName}",
    "messageSent": "Message sent successfully",
    "newMessage": "New Message",
    "order": "Order: {orderId}",
    "recipient": "Recipient",
    "selectToPreview": "Select a message to preview",
    "sendMessage": "Send message",
    "sorting": {
      "createdAsc": "Created (Old to New)",
      "createdDesc": "Created (New to Old)",
      "statusAsc": "Status (A-Z)",
      "statusDesc": "Status (Z-A)",
      "topicAsc": "Topic (A-Z)",
      "topicDesc": "Topic (Z-A)"
    },
    "subject": "Subject: {topic}",
    "to": "To: {recipientName}",
    "viewMessage": "View Message"
  },
  "mini_cart": {
    "empty_cart": "There are no more items left in your cart.",
    "proceed_to_cart": "Proceed to Cart"
  },
  "modals": {
    "licenseArchived": {
      "end": "{contactSupport} to request these products be transferred to an active license to ensure they’re available for ordering.",
      "resultAllProductsWillBeArchived": "<b>All products</b> associated with this license will be archived 7 days after license archiving",
      "resultProductsCannotBeOrdered": "Archived products <b>cannot be ordered</b> or listed on menus",
      "start": "Because your Metrc license {license} was archived, the products assigned to that license will also be archived in {daysLeft} days.",
      "title": "Products To Be Archived"
    },
    "licenseProductsArchived": {
      "end": "{contactSupport} to request these products be transferred to an active license to ensure they’re available for ordering.",
      "resultAllProductsArchived": "<b>All products</b> associated with this license have been archived",
      "resultProductsCannotBeOrdered": "Archived products <b>cannot be ordered</b> or listed on menus",
      "start": "Because your Metrc license {license} was archived 7 or more days ago, the products assigned to that license have also been archived.",
      "title": "Products Archived"
    },
    "routeDetails": {
      "addRouteDetails": "Add Route Details",
      "editRouteDetails": "Edit Route Details",
      "routeDetailsAdded": "Route Details have been successfully added!",
      "routeDetailsSaveError": "There was an error saving route details. Please try again.",
      "routeDetailsUpdated": "Route Details have been successfully updated!",
      "textareaPlaceholder": "Copy and paste route details here"
    },
    "setupDeals": {
      "actionDismiss": "Set up later",
      "actionMain": "Set up LeafLink Deals now",
      "body": "Deals are here! Set up your deals before 7.10 Deals end. Participating in LeafLink Deals is a free opportunity to get your brand in front of more purchasing managers by featuring products on the LeafLink Deals Page.",
      "learnMoreLink": "Learn more about LeafLink Deals",
      "title": "Set Up Deals"
    }
  },
  "notify": {
    "customerUpdated": "Customer Updated",
    "errorChangingLicense": "Error changing license",
    "errorCreateBrand": "Error creating brand",
    "errorCreatingStore": "Error creating store",
    "errorCustomerSupport": "There's an error completing your request, please contact customer support.",
    "errorFetchBrands": "Error fetching Brand Manager brands",
    "errorFetching": "Error fetching data",
    "errorGeneratingMetrcTransfer": "There's an error generating the transfer, please contact logistics support.",
    "errorInviteManager": "Error inviting brand manager",
    "errorNotAuthenticatedRedirect": "Warning: You will be redirected to login in 3 seconds because you are not authenticated.",
    "errorUpdateBrand": "Error updating brand",
    "formSubmissionError": "Your submission has items to review.",
    "licenseWarnings": {
      "getStarted": "To get started, {ctaLink} to your account.",
      "getStartedLink": "add a license",
      "missingExpiration": "One or more of your licenses are missing an expiration date",
      "multipleExpired": "You have multiple licenses that have expired",
      "multipleExpiresSoon": "You have multiple licenses expiring soon",
      "noActiveLicense": "Warning: We are not able to verify any licenses with an active status. Please fix this on the {ctaLink}.",
      "noActiveLicenseLink": "Manage Licenses page",
      "productsArchived": "All products assigned to Metrc license {license} have been archived.",
      "productsArchivedWarning": "All products assigned to Metrc license {license} will be archived in {daysLeft} day. | All products assigned to Metrc license {license} will be archived in {daysLeft} days.",
      "singleExpired": "Your license {number} has expired",
      "singleExpiresSoon": "Your license {number} will expire soon"
    },
    "productUpdated": "Product updated",
    "requiredFieldsError": "Please complete the required fields",
    "sendCatalogProductsCSVToEmailFailure": "Failed to download catalog and send to your email.",
    "sendCatalogProductsCSVToEmailSuccess": "Your download has started and will be delivered to your email associated with your login",
    "successCreatingStore": "Store created successfully!"
  },
  "paymentOnSellThroughEnrollment": {
    "buyerLearnMoreUrl": "https://l.leaflink.com/hubfs/PoST_one%20sheet_for%20buyers.pdf?utm_source=sales&utm_medium=one-pager&utm_campaign=leaflink-post-for-buyers",
    "descriptionLinkCopy": "PoST",
    "dropdown": {
      "acceptTermsTitle": "Accept Terms and Conditions",
      "bankLinkStep": {
        "linkBankSubtitle": "You will be redirected to payments to complete this step.",
        "linkBankTitle": "Link a bank account with Plaid",
        "linkedBankSubtitle": "You can review your bank account in payment settings.",
        "signTermsSubtitle": "Accept terms and conditions to link your bank account.",
        "linkedBankTitle": "Link your bank account",
        "pendingBankSubtitle": "Please check back later to continue bank linking setup.",
        "pendingBankTitle": "Bank account is pending",
        "verifyBankTitle": "Verify your bank account"
      },
      "completionCTA": {
        "buyer": "Shop PoST enabled sellers",
        "seller": "See all PoST buyers"
      },
      "connectMetrcSubtitle": "You will be redirected to settings to complete this step.",
      "connectMetrcTitle": "Connect a Metrc API",
      "description": "{link} structures payment by automatically collecting from retailers as product sells through. You'll also get access to Direct Pay, which allows retailers to pay invoices in full via ACH.",
      "descriptionEnrolled": {
        "buyer": "Anytime you place an order with a seller who accepts PoST, we'll set it as your default payment method. Follow the link below to view our list of trusted PoST enabled Sellers!",
        "seller": "The next time you receive an order from a buyer who has opted into PoST, it'll be set as the default payment method."
      },
      "getStartedSteps": "Follow these steps to get started:",
      "header": "Payment on Sell-Through is here!",
      "headerEnrolled": "You are now enrolled in PoST!",
      "notInterested": "I am not interested in PoST",
      "redirectError": "We can not redirect you at this time. Please try again later."
    },
    "enrollmentModal": {
      "buyer": {
        "directPay": {
          "bulletOne": "Fast and secure digital payment via ACH",
          "bulletOneWithCashback": "0.25% cash back",
          "bulletThree": "Centralize accounts payable",
          "bulletTwo": "Track orders and invoices all in one system"
        },
        "mainContent": "PoST helps retailers retain cash by allowing you to delay payment until the product has sold to the end consumer. By setting up PoST, you'll also get access to Direct Pay, which gives you the option to pay invoices in full via ACH. Click start setup to get started!",
        "noFees": "No fees",
        "post": {
          "bulletOne": "Free up working capital",
          "bulletThree": "Automated payments",
          "bulletTwo": "Mitigate risk of new SKUs"
        }
      },
      "confirm": "Start setup",
      "feesDisclaimer": "*fees may vary",
      "reject": "I don't want PoST",
      "seller": {
        "directPay": {
          "bulletOne": "Secure, digital payments via ACH",
          "bulletThree": "Retailer are incentivized for paying on time",
          "bulletTwo": "Track orders and invoices all in one system"
        },
        "fees": "{percentage} per transaction*",
        "mainContent": "PoST structures payment by automatically collecting from retailers as product sells to the end consumer. Setting up PoST will also give you access to Direct Pay, which allows retailers to pay invoices in full via ACH on a due date you choose. Click start setup to get started!",
        "noFees": "No fees",
        "post": {
          "bulletOne": "Automated payments",
          "bulletThree": "Automated collections",
          "bulletTwo": "Detailed insights into product performance"
        }
      },
      "title": "Payment on Sell-Through (PoST) is now available"
    },
    "notInterestedModal": {
      "characterLimit": "Max 280 characters",
      "comments": "Comments",
      "goBack": "Go back",
      "mainContent": "At LeafLink we strive to solve complex problems to streamline your business and improve your margins. In an effort to continue building products that create value for your business please briefly explain why you are not interested in {link}. Someone from our customer support team may reach out to learn more about how we can best serve your business.",
      "subtitle": "Thanks for letting us know",
      "title": "I do not want PoST"
    },
    "sellerLearnMoreUrl": "https://l.leaflink.com/hubfs/PoST_one%20sheet_for%20sellers.pdf?utm_source=sales&utm_medium=one-pager&utm_campaign=leaflink-post-for-sellers",
    "terms": {
      "disclaimer": "By clicking Accept, you are acknowledging that you've read and agree to the Terms & Conditions.",
      "subtitle": "Terms and Conditions",
      "title": "Payments Terms and Conditions"
    }
  },
  "paymentOnSellThroughOptIn": {
    "cta": "Get Started",
    "learnMore": "Learn more",
    "seller": {
      "description": "PoST helps retailers retain cash by allowing you to delay payment until the product has sold to the end consumer.",
      "enabledDescription": "The next time you receive an order from a buyer who has opted into PoST, it'll be set as the default payment method.",
      "enabledTitle": "You are now enrolled in PoST!",
      "title": "Payment on Sell-Through (PoST) is now available!"
    },
    "buyer": {
      "description": "Use PoST with participating sellers to optimize purchasing strategy and maximize cash on hand.",
      "enabledDescription": "Anytime you place an order with a seller who accepts PoST, we'll set it as your default payment method.",
      "enabledTitle": "You are now enrolled in PoST!",
      "title": "Payment on Sell-Through (PoST) is now available!"
    }
  },
  "paymentsOnboarding": {
    "buyer": {
      "directPay": {
        "howItWorksDesc": "With Direct Pay, invoices must be paid on or before the due date set by the seller.",
        "howItWorksDescWithCashback": "With Direct Pay, invoices must be paid on or before the due date set by the seller. Buyers will earn cash back for each on-time payment.",
        "intro": "Initiate payments directly from your bank account via ACH."
      },
      "flexPay": {
        "howItWorksDesc": "With Flex Pay, invoices must be paid on or before the due date according to the payment terms. A payment processing fee will be assessed and charged to the buyer after the transaction.",
        "intro": "Take advantage of payment terms AND get your seller paid upfront. LeafLink (via FundCanna) will pay the seller upon delivery and collect payment from you later according to your agreed-upon terms."
      }
    },
    "common": {
      "alreadySetUp": "Great news! You’re already set up.",
      "directCta": "Get Started with Direct Pay",
      "directNeed": "Your company’s banking credentials (account and routing numbers) to link an account",
      "everyOnboardedCta": "Payment Preferences",
      "everyOnboardedHeader": "You’re all set!",
      "everyOnboardedSubHeader": "You’ve already enabled all of the LeafLink payments programs, and can use them any time.",
      "flexCta": "Get Started with Flex Pay",
      "flexNeed1": "Your company’s banking credentials and license information",
      "flexNeed2": "Your TIN/EIN, to expedite the approval process",
      "flexNeed3": "Estimated monthly revenue",
      "howItWorks": "How it works:",
      "notOnboardedHeader": "Get started with LeafLink Payments",
      "notOnboardedSubheader": "Select the payment program you’d like to use. You can always add or edit this in the future.",
      "someOnboardedHeader": "Get more out of LeafLink Payments",
      "someOnboardedSubHeader": "You’re already using {paymentProgram} - now’s the time to explore a new payment program for your business.",
      "whatYoullNeed": "What you’ll need:"
    },
    "seller": {
      "directPay": {
        "howItWorksDesc": "With Direct Pay, you set the invoice due date and receive payment from the buyer on or before the due date.",
        "howItWorksDescWithFees": "With Direct Pay, you set the invoice due date and receive payment from the buyer on or before the due date. Sellers will pay a processing fee, which will be auto-debited shortly after each transaction.",
        "intro": "Receive payments directly from your customers via ACH. Each time you request a payment, LeafLink will notify your customer to authorize the payment."
      },
      "flexPay": {
        "howItWorksDesc": "With Flex Pay, invoice due dates are set according to your agreed-upon payment terms. Buyers will pay a fee based on the length of the payment term.*",
        "howItWorksDisclaimer": "*Some sellers may choose to cover the fee for their buyers. If you’d like to do this, contact your LeafLink representative for help.",
        "intro": "Get paid upfront while offering flexible terms to your customers. LeafLink will pay you in full upon delivery and collect payment from the buyer later."
      }
    }
  },
  "regions": {
    "ca": {
      "ab": "Alberta",
      "bc": "British Columbia",
      "mb": "Manitoba",
      "nb": "New Brunswick",
      "nl": "Newfoundland And Labrador",
      "ns": "Nova Scotia",
      "nt": "Northwest Territories",
      "nu": "Nunavut",
      "on": "Ontario",
      "pe": "Prince Edward Island",
      "qc": "Québec",
      "sk": "Saskatchewan",
      "yt": "Yukon"
    },
    "countries": {
      "ca": "Canada",
      "us": "United States"
    }
  },
  "registration": {
    "aboutYou": "About You",
    "beforeYouStart": "Before you get started...",
    "beforeYouStartBody": "Make sure you have the following items handy to reference:",
    "completed": "Completed!",
    "confirmationBody1": "Thanks for applying",
    "confirmationBody2": "Our team is reviewing your application",
    "createRetailerAccount": "Create a Retailer Account",
    "exitRegistration": "Exit Registration",
    "expirationDateAfterIssueDateError": "Must be after the Issue date",
    "howDidYouHear": "How did you hear about us",
    "license": "@:common.license",
    "licenseDocument": "License Document",
    "licenseExpirationDate": "License expiration date",
    "licenseIssueDate": "License issue date",
    "nonRequiredLicenseStateAlert": "To simplify the registration process and ensure compliance, you will be asked to provide your Metrc API Key on platform to add your license(s).",
    "physicalAddress": "Physical Address",
    "referenceItems": {
      "aboutYou": {
        "description": "Name, position, and email",
        "header": "About You"
      },
      "business": {
        "description": "Company name, phone number, TIN/EIN, and addresses",
        "header": "Business info"
      },
      "documents": {
        "description": "Ex. transaction data, tax return, LLC document, sales tax permit, or a tax invoice",
        "header": "Secondary Business Document"
      },
      "license": {
        "description": "Number, type, issue date, expiration, and upload-able file",
        "header": "License"
      }
    },
    "referral": "Referral",
    "referralAndTerms": "Referral & Terms",
    "referralCode": "Referral code",
    "referralSource": "How did you hear about us",
    "registrationCompleted": "Registration Completed",
    "retailerRegistration": "Retailer Registration",
    "review": "Review Information",
    "secondaryBusinessDocument": "Secondary business document",
    "secondaryBusinessDocumentDescription": "For compliance purposes, please provide a copy of another form of official documentation from the state with the entity's name on it (Ex. transaction data, tax return, LLC document, sales tax permit, or a tax invoice).",
    "steps": "Step {step} of 5",
    "submissionSuccess": "Upload successful",
    "submissionSuccessHeader": "Upload successful",
    "submissionWarning": "Do not leave this page!",
    "submissionWarningBody": "Your application is currently loading. Please refrain from navigating away from this page to ensure that you do not lose your progress.",
    "submissionWarningBodySuccess": "All your files have been uploaded successfully.",
    "submissionWarningHeader": "Warning",
    "submit": "Agree and Submit",
    "submitError400": "Failed to register. Please fix errors.",
    "submittingForm": "Application form",
    "submittingLicenseFile": "License",
    "submittingSecondaryFile": "Secondary document",
    "termsAndConditions": "I accept LeafLink's {0} and acknowledge the {1}",
    "termsError": "You must agree to the terms of this agreement to proceed",
    "tinEin": "TIN/EIN",
    "yourBusiness": "Your Business",
    "yourLicenses": "Your Licenses",
    "yourPosition": "Your position",
    "yourUserInfo": "Your user info"
  },
  "s2s": {
    "packages": "Packages"
  },
  "sellerJoinTodayDirect": {
    "bullet1": {
      "description": "Know where your money is at all times, and reduce the risk of theft or fraud.",
      "header": "Secure, trackable payments"
    },
    "bullet2": {
      "description": "Stop wasting hours managing invoices and orders in multiple systems.",
      "header": "Automate and centralized accounts receivable"
    },
    "bullet3": {
      "description": "At 1.25%, LeafLink’s transaction fee is much lower than the 2-4% charged by most banks.",
      "header": "Affordable transactions"
    },
    "bullet4": {
      "description": "LeafLink makes it easier for buyers to manage their outstanding AP and pay you on time.",
      "header": "Make it easier for buyers to pay"
    },
    "bullet4WithCashback": {
      "description": "LeafLink pays buyers cash back for every payment they make via Direct Pay.",
      "header": "Incentivize buyers to pay"
    },
    "ctaButton": "Get started!",
    "pageHeader": "Secure, trackable digital payments",
    "pageSubheader": "With LeafLink Direct Pay, you can keep track of all your orders and payments in one system and eliminate much of the manual work that comes with traditional payment methods. And by giving your buyers an easy way to pay, you’re increasing the chances that you get paid on time.",
    "signUpHeader": "What you'll need to sign up",
    "signUpRequirements": {
      "first": "Your company’s banking credentials (account and routing numbers) to link an account",
      "second": "Up-to-date license information",
      "third": "Your TIN/EIN, which will help verify your business"
    }
  },
  "shippingStatus": {
    "assignedDeliveryDate": "Assigned Delivery Date",
    "assignedTooltip": "Delivery has been requested through LeafLink's Carrier Network",
    "confirmedDeliveryDate": "Confirmed Delivery Date",
    "deliveredTooltip": "Delivery has been completed through LeafLink's Carrier Network"
  },
  "tasks": {
    "dueDateFrom": "Due Date From",
    "dueDateTo": "Due Date To",
    "onlyOwnTasks": "Only show my tasks"
  },
  "termsAndConditions": {
    "accept": {
      "body1": "<p><strong>TERMS AND CONDITIONS FOR PAYMENTS</strong></p>\r\n<p>\r\nThese Payments Retailer Terms and Conditions (“<strong>Retailer Terms</strong>” or “<strong>Agreement</strong>”) is a legally binding contract between you as a licensed purchaser of cannabis (the “<strong>Retailer</strong>” or “<strong>you</strong>”) and Fusion LLF, LLC d/b/a LeafLink Payments (“<strong>LeafLink Payments</strong>” or “<strong>we</strong>”, “<strong>us</strong>”, or “<strong>our</strong>”) a subsidiary of LeafLink, Inc. regarding your use of the LeafLink Payments offering (the “<strong>Program</strong>”). By participating in the Program, you agree to these Retailer Terms, the General Terms and Conditions, and all other terms, policies and guidelines applicable to your use of the Program as presented to you when you use our Site and Service. Defined terms used herein will have the same meaning as in the General Terms and Conditions unless otherwise defined herein.\r\n<p>\r\n<strong>BY USING LEAFLINK PAYMENTS'S SERVICES OR BY CLICKING TO AGREE TO THIS AGREEMENT WHEN THIS OPTION IS MADE AVAILABLE TO YOU, YOU ARE AGREEING TO THESE RETAILER TERMS. IF YOU DO NOT AGREE TO THESE RETAILER TERMS OR ANY OTHER TERMS PROVIDED TO YOU DURING YOUR USE OF LEAFLINK PAYMENTS'S SERVICES, PLEASE DO NOT USE THE SITES OR SERVICES AND EXIT IMMEDIATELY. WE RESERVE THE RIGHT TO MODIFY OR AMEND THESE RETAILER TERMS FROM TIME TO TIME, AND WE WILL PROVIDE YOU WITH NOTICE OF SUCH CHANGE OR CHANGES BY POSTING UPDATES TO THIS PAGE. CHANGES WILL APPLY AND WILL BECOME EFFECTIVE NO SOONER THAN 14 DAYS AFTER THEY ARE POSTED. HOWEVER, CHANGES ADDRESSING NEW FUNCTIONS FOR A SERVICE OR CHANGES MADE FOR LEGAL REASONS WILL BE EFFECTIVE IMMEDIATELY.</strong>\r\n    <p>\r\n1. <strong>THE PROGRAM</strong>. Under the Program, Retailers can purchase goods (“<strong>Merchandise</strong>”) from Vendors and obtain the ability to pay for that Merchandise on terms that may be provided to you in your account on the Site (the “<strong>Payment Terms</strong>”). Payment Terms may be provided for the purchase of Merchandise after Retailer has accepted or retained the Merchandise as described below (each, an “<strong>Approved Transaction</strong>”).\r\n    <p>\r\n2. <strong>PROGRAM REQUIREMENTS</strong>. For all Approved Transactions, the total invoice amount of the Merchandise together with any charges that may be applicable (the “<strong>Obligations</strong>”) shall be due and payable to LeafLink Payments in accordance with the Payment Terms (such time or day, the “<strong>Due Date</strong>”). All of the Obligations will be disclosed to you on the Site prior to your acceptance of the related Payment Terms.\r\n<p>\r\n3. <strong>DELIVERY AND INVOICES</strong>. The time of delivery of the Merchandise shall be established based on the records of Vendor absent manifest error. Each Vendor will deliver to Retailer an invoice for each Approved Transaction (subject to adjustment as set forth below, each an “<strong>Invoice</strong>”). Each Invoice delivered by a Vendor to Retailer is expected to be a representation and warranty from Vendor to Retailer that the Merchandise covered thereby are in saleable form and adheres to all applicable local requirements. You are required to confirm acceptance of Merchandise on our Site. You will also have the right to reject Merchandise covered by an Invoice and received by you if you notify the corresponding Vendor in accordance with applicable local requirements, and if no such local requirements exist you shall provide notice of any rejection within 1 business day. Notwithstanding the foregoing, a Purchase Transaction originated at a time when an Event of Default (as defined below) exists under this Agreement shall be deemed not to be an Approved Transaction, unless LeafLink otherwise notifies you of its acceptance of such transaction.\r\n<p>\r\n4. <strong>PAYMENTS</strong>. Each payment made by you for any Merchandise subject to the Payment Terms offered in the Program, or any extensions or modifications thereof, shall indicate the specific Invoice or Invoices being paid, and Retailer acknowledges and agrees that it shall not make any payment directly to any Vendor. All payments for Merchandise under the Program shall be made directly to LeafLink Payments, and any payments made direct to a Vendor, instead of to LeafLink Payments, for Merchandise that is subject to the Payment Terms shall not be credited towards payment of any of your Obligations.\r\n<p>\r\n5. <strong>DIRECT DEBIT</strong>. For all Approved Transactions, Retailer hereby irrevocably authorizes LeafLink Payments and its assignees to automatically debit the amount of Obligations from the bank account designated by Retailer for payment (the “<strong>Designated Bank Account</strong>”), including via ACH transfer, on the Due Date. With consent of the Retailer, LeafLink Payments or its assignees may debit the amount of Obligations prior to the Due Date. Retailer agrees to update its account on the Site with the current bank account information for the Designated Bank Account at all times. Retailer agrees that it shall maintain a sufficient balance in the Designated Bank Account to cover all Obligations. Retailer agrees that it will, from time to, execute such reasonable and customary documents as may be necessary to enable LeafLink Payments and any assignee to directly debit the Obligations from Retailer's Designated Bank Account. Retailer agrees to provide LeafLink Payments and any assignee of Vendor with written notice of any change in the above information for Retailer's Designated Bank Account immediately upon any such change.\r\n<p>\r\n6. <strong>EVENTS OF DEFAULT</strong>. You acknowledge that each of the following shall constitute an event of default (each an “<strong>Event of Default</strong>”) under this Agreement: (a) Retailer fails to make any payment when due, or Retailer fails to maintain a sufficient balance in the Designated Bank Account to satisfy the Obligations as they become due; (b) Retailer fails to comply with or to perform any obligation, covenant or condition in this Agreement and such failure continues for a period of 10 days or more; (c) any statement provided to LeafLink Payments or the applicable Vendor under this Agreement is false or misleading; or (d) the dissolution or winding down of Retailer, insolvency of Retailer, the appointment of a receiver for any part of Retailer's property, any assignment for the benefit of creditors, any type of creditor workout, or the commencement of any proceeding under any bankruptcy or insolvency laws by or against Retailer. Retailer authorizes LeafLink Payments or its assigns to file at any time and from time to time such financing statements with respect to the Obligations naming Retailer as Retailer/debtor and LeafLink Payments or its assigns as secured party, as may be required.\r\n<p>\r\n7. <strong>CERTAIN FEES</strong>. In the event any Event of Default occurs, then, commencing on the 15th day following the date of such Event of Default, all outstanding Obligations shall accrue interest at the lower of 15% per annum or the maximum rate of interest permitted by Applicable Laws. Additionally, if the Obligations are not paid in full within 15 business days of the Due Date, Retailer will be charged a late fee of 5% of the Invoiced amount in addition to the amount owed. Retailer acknowledges that the late charges payable pursuant to this provision represents a fair and reasonable estimate of the additional expenses LeafLink Payments will incur by reason of such late payment and such late charge is not intended to be treated as a penalty. Payments by Retailer shall be first credited to any late fees due, then to any accrued unpaid interest, then to any unpaid collection charges, and any remainder will be credited to the Invoice amount.\r\n<p>\r\n8. <strong>ASSIGNMENT</strong>. Retailer agrees that this Agreement is assignable by LeafLink Payments and its assignees without prior consent of Retailer. Retailer expressly consents to the assignment of the rights and Obligations arising under this Agreement to one or more payment parties selected by LeafLink Payments or its assignees (each an “<strong>Assignee</strong>”). Upon any such assignment, Vendor or its Assignee (or the Assignees) shall notify Retailer of the assignment, and, thereafter, Assignee shall have all of the rights of LeafLink Payments with respect to collection of the Obligations under this Agreement. It is agreed that the books and records of LeafLink Payments or, upon assignment of rights under this Agreement, the Assignee, shall control in the event of any question or dispute as to whether a transaction is an Approved Transaction or an Obligation have been assigned. This Agreement may not be assigned by Retailer.\r\n<p>\r\n9. <strong>RECORDS OF ACCOUNTS</strong>. You are responsible for maintaining accurate records of all Approved Transactions and all Invoices and related payments. Those records shall be made available to us upon our reasonable request.\r\n<p>\r\n10. <strong>ACCELERATION</strong>. Upon the occurrence of an Event of Default under this Agreement, LeafLink Payments may immediately, at its option, declare all outstanding Obligations to be immediately due and payable. LeafLink Payments may avail itself of any and all rights and remedies available to LeafLink Payments at law or at equity. LeafLink Payments's remedies are cumulative and shall be in addition to all other remedies available at law or in equity.\r\n<p>\r\n11. <strong>COLLECTION COSTS</strong>. If collection action is initiated, or LeafLink Payments or Assignee takes other action to enforce its rights under this Agreement, Retailer shall be responsible for all costs and expenses associated with such collection or enforcement, including, without limitation, attorneys' fees and expenses, whether or not there is a lawsuit, expenses incurred by LeafLink Payments in any bankruptcy proceedings (including efforts to modify or vacate any automatic stay or injunction), and appeals. If not prohibited by Applicable Laws, Retailer also will pay court costs, in addition to all other sums provided by law.\r\n<p>\r\n12. You understand that LeafLink Payments has complete discretion as to whether a Retailer is approved for the Program. LeafLink Payments may, at its option, establish a maximum credit limit applicable to any Retailer. LeafLink Payments may adjust the applicable credit limit from time to time at its discretion. Once approved for the Program, it will be the Retailer's responsibility to designate and credential its employee(s) who will be users of the Program. All actions taken by a Retailer's employees are the responsibility of the Retailer.\r\n<p>\r\n13. <strong>WAIVER; COMMERCIAL PURPOSE</strong>. Retailer waives presentment for payment, notice of dishonor, protest and notice of protest. RETAILER HEREBY WAIVES, TO THE FULLEST EXTENT PERMITTED BY LAW, TRIAL BY JURY. Retailer represents and warrants that this Agreement is solely for the purpose of carrying on a business or commercial enterprise, and not for personal, family or household purposes.\r\n<p>\r\n14. <strong>COMPLIANCE WITH REGULATORY REQUIREMENTS</strong>. This Agreement may be subject to the approval of one or more cannabis regulatory agencies (the “<strong>Regulators</strong>”) and is intended to comply with all rules and regulations promulgated by such regulators (the “<strong>Regulations</strong>”). Notwithstanding anything to the contrary in this Agreement or the general Terms and Conditions, in the event that this Agreement does not obtain any required approval of the applicable Regulators or otherwise is found not to be compliant with any applicable Regulations, the parties hereto and their successors and assigns agree to reform this Agreement in order to obtain the approval of such Regulators or cause this Agreement to be compliant with such Regulations, as applicable.\r\n<p>\r\n15. <strong>REPRESENTATIONS AND WARRANTIES</strong>. Vendor represents and warrants to LeafLink Payments:\r\n<p>\r\n(a) It shall notify LeafLink Payments, and any Assignee, within 24 hours of receiving any material adverse communication from a Governmental Authority that would have a material adverse effect on its ability to conduct its business in compliance with all requirements of Applicable Laws.\r\n<p>\r\n(b) It shall notify LeafLink Payments, and any Assignee, within 24 hours of receiving notice or any communication or indication from a bank or other financial institution that informs Retailer that its account(s) is/are being shut down or suspended for any reason and/or that informs Retailer about the loss or suspension of the Automated Clearing House Network privileges for any reason.\r\n<p>\r\n(c) It is in compliance with the priorities outlined in the Memorandum commonly referred to as the “<strong>Cole Memo</strong>”, dated August 29, 2013, as if such memorandum is in full force and effect as of the date of entering into this Agreement.\r\n<p>\r\n(d) That there are no delinquent taxes or other outstanding charges materially or adversely affecting the Merchandise or the Retailer.\r\n<p>\r\n(e) This Agreement is genuine and is the legal, valid, binding and enforceable obligation of the Retailer.\r\n<p>\r\n(f) The Retailer has the legal capacity to enter into this Agreement and to execute and deliver this Agreement by click through or other electronic record, and this Agreement has been duly and properly executed.\r\n<p>\r\n(g) The Retailer is in compliance with any and all applicable “<strong>doing business</strong>” and licensing requirements under Applicable Laws and of any applicable Governmental Authority.\r\n<p>\r\n12. <strong>DEFINITIONS</strong>. The following capitalized terms used in this Agreement shall have the following meanings:\r\n<p>\r\n(a) “<strong>Applicable Laws</strong>” means, collectively, each international, foreign, federal, state, provincial, territorial, municipal and local statute, treaty, rule, regulation, ordinance, code and administrative or judicial precedent or authority, including, without limitation, to the extent applicable, usury, truth in lending, consumer credit protection, equal credit opportunity, disclosure laws or all predatory, fair and abusive lending laws and other laws applicable to the origination and servicing of the Merchandise of a type similar to the Merchandise, and including the interpretation or administration thereof by any Governmental Authority charged with the enforcement, interpretation or administration thereof, and each applicable administrative order, directive, decree, policies, directed duty, license, authorization and permit of, and agreement with, any Governmental Authority, as the same have been or may in the future be amended from time to time; provided that the Controlled Substances Act (21 U.S.C. § 801 et seq.), and any rules or regulations promulgated thereunder as in effect from time to time, as it may apply to the Merchandise or the parties, is excluded.\r\n<p>\r\n(b) “<strong>Governmental Authority</strong>” means any federal, state, municipal, national, local or other governmental department, court, commission, board, bureau, agency, intermediary, carrier or instrumentality or political subdivision thereof, or any entity or officer exercising executive, legislative or judicial, regulatory or administrative functions of or pertaining to any government or any court, in each case, whether of the United States or a state, territory or possession thereof, a foreign sovereign entity or country or jurisdiction or the District of Columbia.\r\n<p>\r\n13. <strong>OTHER PROVISIONS</strong>. These Retailer Terms and the General Terms and Conditions are a complete statement of the agreement between you and LeafLink Payments regarding the Program and supersedes any and all prior contracts and understandings regarding the Program.\r\n<p>\r\n  <br>\r\n    <h1>TERMS AND CONDITIONS FOR DELIVERY SERVICES</h1>\r\n<p>\r\nThese terms and conditions are made a part of each order placed (together, the “<strong>Purchase Order</strong>”), and together constitute a legally binding contract between you (“<strong>Purchaser</strong>”) and LeafLink Logistics, LLC (collectively \"<strong>LeafLink</strong>\") for the delivery services described in the attached order (the \"<strong>Services</strong>\").\r\n<p>\r\n1. <strong>PURCHASE ORDER AND ACCEPTANCE</strong>: Upon LeafLink's acceptance of this Purchase Order, this Purchase Order is binding and non-cancelable. This Purchase Order, together with any documents specifically referenced herein, represents the entire agreement between the parties. All delivery specifications submitted to LeafLink by Purchaser in connection with this Purchase Order are hereby incorporated herein and made a part hereof. The terms and conditions set forth herein and on the attached order constitute the parties' contractual agreement and supersede any previous oral or written representations, including but not limited to provisions in the parties' prior quotations, proposals, acknowledgments or other documents. No course of dealing or usage of trade shall be applicable unless expressly incorporated by this Purchase Order. The terms of this Purchase Order may not be varied or modified in any manner, unless in a subsequent writing signed by an authorized representative of each of LeafLink and Purchaser.\r\n<p>\r\n2. <strong>DELIVERY TERMS AND PERFORMANCE</strong>. The Services purchased by Purchaser shall be effected in accordance with the delivery schedule set out or referred to in this Purchase Order; provided, that, LeafLink shall not be liable for delays or defaults due to causes beyond its control. Purchaser acknowledges and agrees that: (i) no Services purchased by Purchaser hereunder shall be conducted or fulfilled by LeafLink or any affiliate thereof, but instead are intended to be, and shall be, conducted and fulfilled by a thirdparty contractor (the “<strong>Delivery Company</strong>”); (ii) to the extent that Purchaser incurs any loss resulting from the failure of Delivery Company to perform the Services in accordance with the terms of this Purchase Order, (x) Purchaser shall have the right to pursue against Delivery Company all rights and remedies under the applicable contract between LeafLink and Delivery Company and under applicable law, and (y) LeafLink shall have no liability to Purchaser in respect thereof.\r\n<p>\r\n3. <strong>WARRANTY AND DISCLAIMER</strong>: LeafLink warrants that the services under this Purchase Order will be performed in a professional and workmanlike manner. LEAFLINK'S WARRANTY IS IN LIEU OF ALL OTHER WARRANTIES, EXPRESS, IMPLIED OR STATUTORY, INCLUDING ANY WARRANTY OF MECHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE OR NONINFRINGEMENT. LEAFLINK SPECIFICALLY DISCLAIMS ANY AND ALL WARRANTIES, EXPRESS OR IMPLIED, TO CUSTOMERS OF PURCHASER.\r\n<p>\r\n4. <strong>PRICE TERMS</strong>. The services will be furnished at the price set forth on the face side of this Purchase Order in U.S. dollars. Purchaser shall pay for the services within thirty (30) days following LeafLink's certification that the services are complete. LeafLink, in its sole discretion, shall determine completion of services. Prices do not include taxes. Where appropriate, any applicable taxes, will be added to the invoice and paid by Purchaser. Any amounts not paid when due shall bear interest at the rate of ten percent (10%) per month or at the highest rate permitted by law (whichever is less), from the date due until paid.\r\n<p>\r\n5. <strong>NON-SOLICITATION</strong>. Purchaser agrees that, for a period of six (6) months after completion of the Services under this Purchase Order, neither Purchaser nor any of its affiliates shall directly or indirectly, for itself or on behalf of another person, solicit, divert, appropriate, or enter into any agreement for Services (or any other services reasonably related thereto) with any Delivery Company or any affiliate of any Delivery Company.\r\n<p>\r\n6. <strong>CANNABIS LAWS. In order to comply with all Applicable Law (as defined below), the Parties believe this Agreement establishes an arm's-length transaction, such that neither Party shall be seen as exerting any control, management, direction or ownership over the other. To ensure continued compliance with Applicable Law, in the event the Parties or any governmental entity determine this Agreement (i) no longer establishes an arm's length transaction or (ii) establishes control, management, direction or ownership by one Party over the other, this Agreement may be adjusted to reflect an arm's-length transaction between the Parties or remove any control, management, direction or ownership by one Party over another, as applicable.</strong> The parties hereto agree and acknowledge that no party makes, will make, or shall be deemed to make or have made any representation or warranty of any kind regarding the compliance of this Purchase Order with any Federal Cannabis Laws. No party hereto shall have any right of rescission or amendment arising out of or relating to any non-compliance with Federal Cannabis Laws unless such non-compliance also constitutes a violation of applicable state law as determined in accordance with applicable laws, and no party shall seek to enforce the provisions hereof in federal court. As used herein, “<strong>Federal Cannabis Laws</strong>” means any U.S. federal laws, civil, criminal or otherwise, as such relate, either directly or indirectly, to the cultivation, harvesting, production, distribution, sale and possession of cannabis, marijuana or related substances or products containing or relating to the same (“<strong>Cannabis Products</strong>”), including, without limitation, the prohibition on drug trafficking under 21 U.S.C. § 841(a), et seq., the conspiracy statute under 18 U.S.C. § 846, the bar against aiding and abetting the conduct of an offense under 18 U.S.C. § 2, the bar against misprision of a felony (concealing another's felonious conduct) under 18 U.S.C. § 4, the bar against being an accessory after the fact to criminal conduct under 18 U.S.C. § 3, and federal money laundering statutes under 18 U.S.C. §§ 1956, 1957, and 1960 and the regulations and rules promulgated under any of the foregoing. Each party understands that changes in applicable law could limit aspects of this Purchaser Order or render portions of this Purchase Order unenforceable, and as a result, the parties expressly acknowledge and agree that this Purchase Order shall be read down such that it does not contravene any applicable law that would render all or a portion of this Purchase Order unenforceable or would restrict the transactions contemplated hereby, or the relationship of the parties hereto. In the event that any provision of this Purchase Order is rendered invalid or unenforceable by a court of competent jurisdiction, or the applicable laws and regulations are altered by any legislative or regulatory body, the remaining provisions, if any, of this Purchase Order shall nevertheless continue in full force and effect; provided that any provisions that have been declared null, void, unenforceable, or in violation of applicable laws (including any of those relating to payments or deliverables required hereunder) shall be replaced with provisions providing substantially equivalent consideration, determined by the parties acting reasonably and in good faith. The Parties also hereby agree to waive illegality as a defense to contractual claims arising out of this Purchase Order. PURCHASER ACKNOWLEDGES AND AGREES THAT, IN THE PERFORMANCE OF SERVICES OR OTHERWISE, NEITHER LEAFLINK NOR ANY OF ITS AFFILIATES SHALL EVER TAKE, OR BE DEEMED TO HAVE TAKEN, DIRECTLY OR INDIRECTLY, POSSESSION OR CONTROL OF, OR ANY RELATED ACTION WITH RESPECT TO, ANY CANNABIS PRODUCT. LEAFLINK DOES NOT POSSESS, AND DOES NOT HOLD ITSELF OUT AS POSSESSING, A LICENSE FROM ANY STATE TO TRANSACT ANY BUSINESS RELATING TO ANY COMMERCIAL CANNABIS ACTIVITY, INCLUDING, BUT NOT LIMITED TO, THE PURCHASE, SALE, POSSESSION, TRANSPORTATION, AND/OR DELIVERY OF MEDICAL OR ADULT-USE CANNABIS. PURCHASER ASSUMES ALL CRIMINAL AND CIVIL RISK RELATED TO ANY PROPOSED OR ACTUAL TRANSACTION CONTEMPLATED HEREBY. PURCHASER IS RESPONSIBLE FOR ENSURING THE LEGALITY OF ANY SUCH TRANSACTION. LEAFLINK DISCLAIMS ALL RESPONSIBILITY OR LIABILITY FOR ANY LOSS RELATED TO THE PURCHASE, SALE, CULTIVATION, POSSESSION, MANUFACTURE, OR DISTRIBUTION OF CANNABIS BY PURCHASER OR ANY OTHER PERSON IN CONNECTION WITH THE SERVICES. LEAFLINK MAKES NO REPRESENTATION OF ANY KIND WHATSOEVER THAT THE TRANSACTIONS CONTEMPLATED HEREBY ARE LAWFUL UNDER ANY FEDERAL, STATE, OR LOCAL LAW.\r\n<p>\r\n7. <strong>REPRESENTATIONS, WARRANTIES, AND COVENANTS</strong>. Purchaser hereby represents, warrants, and covenants to LeafLinkthat: (i) Purchaser maintains, and shall maintain, for the duration of the term of this Agreement, in good standing, all licenses, permits, approvals, and/or related requirements required by applicable law (other than Federal Cannabis Laws) to conduct the activities contemplated by this Purchase Order, including, without limitation, the possession, manufacturing, and distribution of Cannabis and Cannabis-related products; (ii) Purchaser will comply in all material respects with each law, rule, statute, subordinate legislation, regulation, by-law, order, ordinance, protocol, code, guideline, policy, notice, direction or judicial, arbitral, administrative, ministerial or departmental judgment, or other requirement or guideline published or in force at any time that applies to or is otherwise intended to govern or regulate any person property, transaction, activity, event or other matter, including any rule, order, judgment, directive or other requirement or guideline issued by any governmental or regulatory authority (other than Federal Cannabis Laws); (iii) upon request, Purchaser shall provide LeafLink with any requested Cannabis-related license and permit information with respect to applicable state and local laws, including but not limited to License Number, License Type, Issue Date and Expiration Date; Purchaser shall immediately notify LeafLink of any change in the status of Purchaser's legal authorization to possess, transport, and/or deliver Cannabis, including the expiration, suspension, cancellation, revocation, nonexistence or invalidation of any Cannabis-related license to which Purchaser or an affiliate thereof is or should be subject under applicable laws, including any state or local laws and/or regulations or administrative guidance issued thereunder; (iv) Purchaser shall immediately notify LeafLink of any warnings, orders, penalties and sanctions received from any state or local government regulatory or licensing authority in the United States related to noncompliance with any state or local laws and/or regulations or administrative guidance issued thereunder related to the possession, processing, purchase or sale, cultivation, transportation, distribution, and/or delivery of Cannabis, and any disciplinary actions, inspections, suspensions or cancellations of any Cannabis-related authorization, approval, consent, license or permit held by Users or affiliates.\r\n<p>\r\n8. <strong>TERMINATION</strong>: Purchaser's order shall be deemed Purchaser's representation that Purchaser is solvent and able to pay for the services LeafLink provides. If Purchaser fails to make payments on this or any other Purchase Order when due, or if Purchaser: (i) becomes insolvent or a bankruptcy petition is filed which is not vacated within thirty days from the date of filing; (ii) breaches the terms and conditions of this Purchase Order; (iii) fails upon request to provide LeafLink with reasonable assurances of future performance; (iv) makes an assignment for the benefit of creditors; (v) commences any receivership or like proceedings relating to assets; or (vi) is a party to a merger, consolidation or other extraordinary corporate transaction in which it is not the surviving entity, Purchaser will be deemed in default and LeafLink shall have the right to terminate or suspend its obligations without further notice to Purchaser, but such termination or suspension shall not affect Purchaser's obligation to pay for services delivered and work in progress, and LeafLink shall not be liable to Purchaser for any amount. Purchaser shall be liable to LeafLink for all damages, direct or indirect, consequential and incidental, sustained by reason of the default which gave rise to the termination, including, without limitation, interest and late charges.\r\n<p>\r\n9. <strong>RIGHTS, REMEDIES AND CONSTRUCTION</strong>: A waiver by either party of any right or remedy shall not affect any rights or remedies subsequently arising under the same or similar clauses. The failure of either party to insist upon the performance of any term or condition of this Purchase Order, or to exercise any right hereunder shall not be construed as a waiver of the future performance of any such term or condition or the exercise in the future of any such right. If any term of this Purchase Order is invalid or unenforceable under any statute, regulation, ordinance, executive order or other rule of law, such term shall be deemed reformed or deleted, but only to the extent necessary to comply with such statute, regulation, ordinance, order or rule, and the remaining provisions of this Purchase Order shall remain in full force and effect.\r\n<p>\r\n10. <strong>CONFIDENTIALITY AND DATA SECURITY</strong>. Each party acknowledges that its respective performance of its obligations hereunder may require that it have access to confidential business and proprietary information of the other. Each party agrees on behalf of itself and its officers, directors, employees and agents to use its/their best efforts to prevent either duplication or disclosure of data, plans, specifications, formulae, drawing, personal information or any other information whether business or technical, of a confidential nature, which has been furnished directly or indirectly, in writing or otherwise to the other. Each party shall use all reasonable legal, organizational, physical, administrative, and technical measures, and security procedures to safeguard and ensure the security of Confidential Information, and to protect it from unauthorized access, disclosure, duplication, use, modification, or loss. \"<strong>Confidential information</strong>\" shall include such information as would be apparent to a reasonable person, familiar with the disclosing party's business and the industry in which it operates, that such information is of a confidential or proprietary nature and that maintenance of its confidentiality would likely be of commercial value to the disclosing party. “<strong>Confidential information</strong>\" shall not include information that is in the public domain prior to its disclosure, becomes part of the public domain through no wrongful act of the receiving party, was in the lawful possession of the receiving party prior to its disclosure to the receiving party or was independently developed by the receiving party. The receiving party shall not disclose the disclosing party's Confidential Information to any person or entity, except to the receiving party's employees who have a need to know the Confidential Information for the receiving Party to exercise its rights or perform its obligations hereunder. Notwithstanding the foregoing, each party may disclose Confidential Information to the limited extent required in order to comply with the order of a court or other governmental body, or as otherwise necessary to comply with applicable law, provided that the party making the disclosure pursuant to the order shall first have given written notice to the other party and made a reasonable effort to obtain a protective order; or to establish a party's rights under this Purchase Order, including to make required court filings. On the expiration or termination of this Purchase Order, the receiving party shall promptly return to the disclosing party all copies, whether in written, electronic, or other form or media, of the disclosing party's Confidential Information, or destroy all such copies and certify in writing to the disclosing party that such Confidential Information has been destroyed.\r\n<p>\r\n11. <strong>LIMITATION ON LEAFLINK'S LIABILITY</strong>: In no event shall LeafLink or any of its affiliates be liable to Purchaser or any other person or entity for anticipated profits or for special, punitive, exemplary, incidental or consequential damages arising out of or in connection with this transaction or any acts or omissions associated therewith or relating to the services provided, whether such claim is based on breach of warranty, contract, tort or other legal theory and regardless of the causes of such loss or demand or whether any other remedy provided herein fails. LeafLink's liability for a claim of any kind for any loss or damage arising out of or in connection with or resulting from this Purchase Order, or from any breach, shall in no\r\ncase exceed the total amount paid for services purchased under this Purchase Order.\r\n<p>\r\n12. <strong>INDEMNITY</strong>. Purchaser agrees to defend, indemnify and hold LeafLink and any affiliated company or individual harmless from any and all liabilities, costs, and expenses, including reasonable attorneys' fees, related to or in connection with (i) the use of the Services; (ii) Purchaser's violation of any term of this Purchase Order, including without limitation, Purchaser's breach of any of the representations and warranties above; and/or (iii) Purchaser's violation of any law, rule or regulation of the United States or any other country.\r\n<p>\r\n13. <strong>FORCE MAJEURE</strong>: Neither party shall be liable for defaults due to acts of God or the public enemy, acts or demands of any government or any government agency, strikes, fires, floods, accidents, strikes, freight embargoes, or other unforeseeable causes beyond its control. Each party shall notify the other in writing of the cause of such delay within five (5) days after the beginning thereof.\r\n<p>\r\n14. <strong>RELATIONSHIP OF PARTIES</strong>: LeafLink and Purchaser are independent contracting parties and nothing in this Purchase Order shall make either party the agent or legal representative of the other for any purpose whatsoever, nor does it grant either party any authority to assume or to create any obligation on behalf of or in the name of the other party.\r\n<p>\r\n15. <strong>LAW</strong>: The rights and obligations of the parties and the terms identified herein and elsewhere in any existing purchase order shall be governed by and construed in accordance with the domestic laws of the state or commonwealth in which the services contemplated by this Purchase Order are performed. \r\n<p>\r\n16. <strong>DISPUTE RESOLUTION AND ARBITRATION</strong>. In the interest of resolving disputes between Purchaser and LeafLink in the most expedient and cost effective manner, Purchaser and LeafLink agree that every dispute arising in connection with this Purchase Order will be resolved by binding arbitration, to the fullest extent permitted under applicable law. This agreement to arbitrate disputes includes all claims arising out of or relating to any aspect of this Purchase Order, whether based in contract, tort, statute, fraud, misrepresentation, or any other legal theory, and regardless of whether a claim arises during or after the termination of this Purchase Order. PURCHASER UNDERSTANDS AND AGREES THAT, BY ENTERING INTO THESE TERMS, PURCHASER AND LEAFLINK ARE EACH WAIVING THE RIGHT TO A TRIAL BY JURY OR TO PARTICIPATE IN A CLASS ACTION, TO THE FULLEST EXTENT PERMITTED UNDER APPLICABLE LAW. Despite the provisions of this section, nothing in this Purchase Order will be deemed to waive, preclude, or otherwise limit the right of either party to: (i) bring an individual action in small claims court; (ii) pursue an enforcement action through the applicable federal, state, or local agency if that action is available; or (iii) seek injunctive relief in a court of law. To the fullest extent permitted under applicable law, any arbitration between Purchaser and LeafLink will be settled under the Federal Arbitration Act, and governed by the Commercial Dispute Resolution Procedures and the Supplementary Procedures for Consumer Related Disputes (collectively, “<strong>AAA Rules</strong>”) of the American Arbitration Association (“<strong>AAA</strong>”), as modified by this Purchase Order, and will be administered by the AAA. Any arbitration hearing will take place at a location to be agreed upon in New York, New York, but if the claim is for $10,000 or less, Purchaser may choose whether the arbitration will be conducted: (i) solely on the basis of documents submitted to the arbitrator; (ii) through a non-appearance based telephone hearing; or (iii) by an inperson hearing as established by the AAA Rules in the county (or parish) of Purchaser's billing address. If the arbitrator finds that either the substance of Purchaser's claim or the relief sought in the demand s frivolous or brought for an improper purpose (as measured by the standards set forth in Federal Rule of Civil Procedure 11(b)), then the payment of all fees will be governed by the AAA Rules. In that case, Purchaser agrees to reimburse LeafLink for all monies previously disbursed by it that are otherwise Purchaser's obligation to pay under the AAA Rules. Regardless of the manner in which the arbitration is conducted, the arbitrator must issue a reasoned written decision sufficient to explain the essential findings and conclusions on which the decision and award, if any, are based. The arbitrator may make rulings and resolve disputes as to the payment and reimbursement of fees or expenses at any time during the proceeding and upon request from either party made within 14 days of the arbitrator's ruling on the merits. To the fullest extent permitted under applicable law, no action arising out of, in connection with, or relating to this Purchase Order shall be brought by Purchaser more than one (1) year after the accrual of the cause of action. This period shall not be extended for any reason, except by the written consent of both parties. All statutes or provisions of law which would toll or otherwise affect the running of the period of limitation are hereby waived, and no such statute or provision of law shall operate to extend the period limited in this paragraph, to the fullest extent permitted under applicable law.\r\n<p>\r\n17. <strong>NOTICES</strong>. Notices shall be sent by a nationally recognized overnight courier service to the addresses specified on the face hereof and shall be effective one day after dispatch.",
      "checkboxLabel": "I acknowledge the Terms & Conditions",
      "heading1": "Please review and accept our new Terms & Conditions",
      "subtitle": "We've updated our Terms and Conditions to cover our Payments and Logistics offerings."
    },
    "directPayTermsConfirmation": {
      "buyer": {
        "bullet1": "Automate and centralize accounts payable",
        "bullet1WithCashback": "Earn cash back on every purchase",
        "bullet2": "$0 transaction fee for retailers",
        "bullet3": "Secure, trackable payments",
        "cashBackRate": "0.25%",
        "cashBackRateDescription": "Cash back per transaction",
        "modalHeader": "Sign up to pay via LeafLink"
      },
      "legalNotice": "By clicking Accept, you are acknowledging that you've read and agree to the Terms & Conditions.",
      "seller": {
        "bullet1": "Get paid next day instead of waiting several days for a typical ACH",
        "bullet2": "Included with your LeafLink membership plan",
        "bullet2WithFees": "Lower fee compared to many other ACH providers",
        "bullet3": "Securely process payments with trusted financial institutions",
        "bullet4": "Eliminate the need for manual reconciliation",
        "modalHeader": "Sign up to get paid via LeafLink",
        "processingRate": "1.25%",
        "processingRateDescription": "Processing fee per Direct Pay transaction"
      },
      "termsBody": "<p><strong>Embedded Payments Terms &amp; Conditions</strong></p> <p><i><span>Last updated as of April 2024</span></i></p> <p><span>These Payment Terms (these “<b>Payment Terms</b>”) are a legally binding contract between you and LeafLink, Inc. (collectively, &quot;<b>LeafLink</b>&quot; or &quot;<b>we</b>&quot;, &quot;<b>us</b>&quot;, or &quot;<b>our</b>&quot;) regarding your use of LeafLink’s ACH Service (as defined below) and/or LeafLink’s Payment on Sell Thru Service (as defined below, and together with the ACH Service, the “<b>Embedded Payment Services</b>”)). By using the Embedded Payment Services, you agree to be bound by these Payment Terms, as well as LeafLink’s&nbsp;</span><span><a href=\"https://www.leaflink.com/terms-and-conditions\"><span >Terms and Conditions of Use</span></a></span><span> or Master Subscription Agreement, as applicable,&nbsp;</span><span><a href=\"https://www.leaflink.com/privacy-policy\"><span >Privacy Policy</span></a></span><span>, and all other terms and policies applicable to the Embedded Payment Services.</span></p> <p><span>You agree that the Embedded Payment Services are each included in the definition of “Services” under the Terms and Conditions of Use or Master Subscription Agreement, as applicable. If you use any of the Embedded Payment Services on behalf of a business, that business accepts these Payment Terms, as well as LeafLink’s Terms and Conditions of Use or Master Subscription Agreement, as applicable, Privacy Policy and all other terms and policies applicable to the Embedded Payment Services. Capitalized terms used but not defined in these Payment Terms shall have the meaning(s) in the Terms and Conditions of Use or Master Subscription Agreement, as applicable.</span></p> <p><b><span>1.&nbsp;Embedded Payment Services.</span></b></p> <p><span>(a) ACH Services. LeafLink offers services that allow you to initiate Automated Clearing House (“<b>ACH</b>”) debit or credit Entries (the “<b>ACH Service</b>”, also referred to as “<b>Direct Pay</b>”). To offer the ACH Service, LeafLink works with third-party Financial Institutions, and you hereby authorize LeafLink’s Financial Institutions to originate entries on your behalf.</span></p> <p><span>(b) Payment on Sell Thru. LeafLink offers services that allow licensed Retailers to pay for wholesale Cannabis Products only when you have sold such Cannabis Products to your customers (“<b>Payment on Sell Thru</b>” or “<b>PoST</b>”. Additionally, LeafLink offers services that allow licensed Vendors to receive payments within sixty (60) days of delivering wholesale Cannabis Products to a Retailer that is participating in PoST.</span></p> <p><span>(c) In connection with the enrollment of your bank account in the Embedded Payment Services (your “<b>Enrolled Bank Account</b>”), you agree to use LeafLink’s account validation service provider and provide any such additional information that LeafLink may determine is necessary to validate your account or use the Embedded Payment Services.</span></p> <p><b><span>2. Fees.</span></b></p> <p><span>You agree to pay LeafLink all fees and charges for use of the Embedded Payment Services as presented and accepted on the Sites, together with other amounts owed pursuant to these Payment Terms or as may be presented during your use of the Embedded Payment Services (“<b>Fees</b>”). Such other amounts shall include any amounts, including insufficient fund or similar fees, charged to LeafLink, the underlying Financial Institution, or you by NACHA, the administrator of the ACH Network, in connection with your use of the Embedded Payment Services. All Fees are charged at the time we process a transaction, and you will be billed for all transactions occurring within a given month within the first fourteen (14) days of the following month. You also grant us Recovery Authorizations, which we may utilize to recover Fees you owe us. Subject to the Terms and Conditions of Use or Master Subscription Agreement, as applicable, and these Payment Terms, we reserve the right to change the Fees upon reasonable advance notice. All Balances and all Fees, charges, and payments collected or paid through the Embedded Payment Services are denominated in US dollars, unless otherwise stated.</span></p> <p><b><span>3.&nbsp;Transaction Limits.</span></b></p> <p><span>You shall operate and use the Embedded Payment Services in accordance with the transaction limits approved by LeafLink and in accordance with the NACHA Operating Rules (“<b>NACHA Rules</b>”). LeafLink may, in its sole discretion, modify your transaction limits at any time upon notice to you.</span></p> <p><b><span>4. Types of Entries.</span></b></p> <p><span>LeafLink will transmit Entries that you initiate that fully comply with LeafLink’s requirements, which are generally consistent with the following ACH Standard Entry Class (“<b>SEC</b>”) Code: WEB.</span></p> <p><b><span>5. Compliance.</span></b></p> <p><span>You agree to comply with the rules, guidelines and bylaws of NACHA (available on the NACHA&nbsp;<b>website</b>) and other applicable laws and regulations related to the operation and use of the ACH Network, which may include Uniform Commercial Code Article 4A or Regulation E, as each is amended from time to time. The foregoing rules, guidelines, bylaws, laws and regulations shall all be deemed part of (and included in) the definition of “Network Rules,” and NACHA shall be included in the definition of “Networks,” both as defined in the Payment Terms.</span></p> <p><b><span>6. Authorizations.</span></b></p> <p><span>(a) Balance check. You hereby authorize LeafLink and its Financial Institutions to perform a Balance check of your Enrolled Bank Account at any time and as frequently as LeafLink deems necessary, in its sole discretion. In the event that LeafLink determines your Enrolled Bank Account has an insufficient Balance, LeafLink will use commercially reasonable efforts to notify you. </span></p> <p><span>(b) Debit and credit authorization. You hereby authorize LeafLink and its Financial Institutions to debit and credit your bank account for ACH Entries, and you are solely responsible for ensuring such authorizations comply with the Network Rules and applicable law. When you use the Embedded Payment Services to initiate ACH Entries, you represent and warrant that you have all necessary authorizations and approvals for LeafLink to originate an ACH debit or credit Entry to the customer’s bank account and that each such Entry is accurate and timely. You further warrant that any debit Entry that you initiate satisfies an obligation or corrects an error. LeafLink shall not be liable for any return, reversal or other failure (or any related costs) arising from your acts and omissions, including failure to obtain your customer’s authorization for an ACH debit transaction. </span></p> <p><span>(c) Track and trace. You agree that LeafLink is permitted to receive data from your track and trace software (e.g., Metrc, BioTrack) account (“<b>Tracking Account</b>”). You agree that, for as long as you are using any of the Embedded Payment Services, you will not disconnect your Tracking Account from the Sites. You also agree that you will immediately notify LeafLink of any changes to your Tracking Account.</span></p> <p><span>(d) Record retention. You agree that LeafLink is permitted to document and store ACH authorizations, including timestamp and applicable ACH credentials. You further agree that you shall retain authorization for each Entry you originate for two (2) years after termination or revocation of such authorization or for such other period as required by the Network Rules.</span></p> <p><span>7.&nbsp;<b>Sufficient Funds; Suspension and Termination.</b></span></p> <p><span>You agree to maintain sufficient funds in your Enrolled Bank Account to satisfy all Fees and Embedded Payment Service-related payment obligations. In addition to the termination rights set forth in the Terms and Conditions of Use or Master Subscription Agreement, as applicable, LeafLink may suspend or terminate your use of the Embedded Payment Services for violation of any Network Rules, including, without limitation, acceptable limits for ACH returns and failure to maintain funds in your Enrolled Bank Account to satisfy your obligations under these Payment Terms. LeafLink may also terminate or suspend the Embedded Payment Services if the Financial Institution requires such suspension or termination.</span></p> <p><b><span>8. Settlement.</span></b></p> <p><span>(a) You acknowledge that funds paid to you by your customers through the Embedded Payment Services shall only be made available to you once the Financial Institution receives final settlement. In the event that LeafLink makes available to you any provisional credit and such Financial Institution does not receive the final settlement, the Financial Institution is entitled to a refund for the amount of the provisional credit. You agree that you shall be responsible for all such refunds, and LeafLink shall have the right to be reimbursed and recover such refunds or other amounts that are charged to LeafLink by the Financial Institution in connection with the Embedded Payment Services pursuant to these Payment Terms.</span></p> <p><span>(b) You acknowledge and agree that (i) LeafLink does not receive funds from your customers for the purpose of remitting them to you in connection with any of the Embedded Payment Services; (ii) all funds are received and transferred by Leaflink’s third-party Financial Institutions; and (iii)&nbsp;LeafLink’s role is limited to submitting payment information on your behalf to such Financial Institutions. In the event that LeafLink were to receive or be deemed to have received customer funds intended for transfer to you, you agree that (A) in receiving a customer’s funds and remitting them to you, LeafLink is acting as your agent for the limited purpose of facilitating the sale of your goods and services to such customer; (B) LeafLink’s receipt of the customer’s payment as your agent constitutes your receipt of such payment and satisfies the customer’s obligation to you in the amount of such payment; and (C) you shall have recourse only against LeafLink, and not against the customer, for any payment LeafLink is deemed to have received and failed to remit to you.</span></p> <p><b><span>9. Cancellation, Amendment, Reversal.</span></b></p> <p><span>(a) You shall not have the right to cancel, amend, or reverse an ACH Entry after its receipt by LeafLink; nonetheless, upon your request, LeafLink may, in its sole discretion, use reasonable efforts to cancel, amend or reverse an Entry before transmitting to the ACH Network or processing it as an on-us Entry. LeafLink shall have no liability if it fails to effectuate such requests.</span></p> <p><span>(b) LeafLink reserves the right, in its sole discretion, to cancel, amend, or reverse an ACH Entry at any time and for any reason. LeafLink also reserves the right, in its sole discretion, to pause, freeze, or shut down your Enrolled Bank Account’s access to the Embedded Payment Services for any reason.</span></p> <p><b><span>10. Rejection.</span></b></p> <p><span>LeafLink or the Financial Institution may reject any Entry, including an on-us Entry, that does not comply with the requirements of these Payment Terms or the Network Rules, and may reject any Entry if you are not otherwise in compliance with these Payment Terms. In addition, the Financial Institution may refuse to process an Entry you initiate in its sole discretion. You shall be responsible for correcting any Entries rejected by LeafLink or the Financial Institution prior to resubmission.</span></p> <p><b><span>11. Returns.</span></b></p> <p><span>When using the Embedded Payment Services, you understand and agree that it may take more than 60 days for LeafLink to receive notice of a return or reversal of an ACH Entry and for LeafLink to exercise any of our rights granted or reserved under these Payment Terms, the Terms and Conditions of Use or Master Subscription Agreement, as applicable, or the Network Rules. You agree to maintain Sufficient Balance in your linked Enrolled Bank Account to satisfy all obligations to LeafLink in connection with your use of the Embedded Payment Services, including returns, reversals, and associated fees, and to add funds immediately if LeafLink notifies you that your funds in your linked Enrolled Bank Account are insufficient. LeafLink reserves the right to recover all outstanding amounts due to LeafLink in accordance with the following Recovery Authorizations provisions:</span></p> <p><span>(a) In addition, by using the Embedded Payment Services, you authorize us to recover funds from you in accordance with these Payment Terms, the Terms and Conditions of Use or Master Subscription Agreement, as applicable, and any other agreement you have with us (“Recovery Authorizations”). Recovery Authorizations include your authorization of LeafLink to debit, charge, setoff against and otherwise recover funds from any connected Enrolled Bank Account, any Balance, any Reserve (as defined in these Payment Terms), any payment instrument, linked bank, depository and other account registered in your Enrolled Bank Account.</span></p> <p><span>(b) Further, in the event that any attempt to recover funds from you should fail, Recovery Authorizations include your grant to LeafLink of new, original authorizations to recover all or less than all of the amount you owe us and/or belong to us. Recovery Authorizations include all authorizations to take the above steps without prior notice to you and irrespective of (i) whether we have made demand under these Payment Terms, the Terms and Conditions of Use or Master Subscription Agreement, as applicable, or any other agreement you have with us; and (ii) whether the obligation is contingent, matured or unmatured. Recovery Authorizations include all authorizations to take the above steps in complete compliance with the Network Rules (as defined in these Payment Terms) and the NACHA Rules. You agree that your grant of Recovery Authorizations to us has the same legal effect as if you had signed a paper containing the same terms.</span></p> <p><span>(c) LeafLink may enter into agreements with one or more insurance companies (“<b>LeafLink’s Insurers</b>”) for insurance coverage of the Embedded Payment Services. You agree to cooperate with LeafLink’s Insurers, as may be reasonably requested by LeafLink or LeafLink’s Insurers.</span></p> <p><b><span>12. Violation of Laws.</span></b></p> <p><span>You represent, warrant, and covenant to LeafLink, as an Originator of Entries made under the Operating Rules, that (a) you will not seek to use the Embedded Payment Services in violation of any applicable law or regulation; and (b) no Entry delivered to LeafLink or the Financial Institution, if accepted by the Financial Institution, will cause LeafLink or the Financial Institution to be in violation of any regulation or sanction administered by the federal or state government or otherwise causes LeafLink or the Financial Institution to be in violation of federal or state law.</span></p> <p><b><span>13. Audit and Review.</span></b></p> <p><span>You agree to permit LeafLink, the Financial Institutions and their designated third parties to audit, inspect, and review your policies and processes for purposes of ensuring your compliance with these Payment Terms and the Network Rules. You agree to cooperate with any such audit and to respond to reasonable requests for information necessary to complete such audit in a timely manner.</span></p> <p><b><span>14. Additional Limitation of Liability.</span></b></p> <p><span>In addition to any limitation of liability contained in the Terms and Conditions of Use or Master Subscription Agreement, as applicable, LeafLink shall not be liable for any action or inaction by the Financial Institution or a third party that results in LeafLink’s failure to perform under these Payment Terms or suspension, termination, restriction or other delay in LeafLink’s performance under these Payment Terms.</span></p> <p><b><span>15. Additional Indemnity.</span></b></p> <p><span>In addition to any indemnity clause contained in the Terms and Conditions of Use or Master Subscription Agreement, as applicable, you will indemnify, defend, and hold us and our processors (and our and their respective employees, directors, agents, affiliates and representatives) harmless from and against any and all claims, costs, losses, damages, judgments, Tax assessments, penalties, interest, and expenses (including reasonable attorneys’ fees) arising out of any claim, action, audit, investigation, inquiry, or other proceeding instituted by a person or entity that arises out of or relates to (a) your breach of any representation, warranty or covenant set forth in these Payment Terms, (b) your failure to perform your obligations as an Originator under the Network Rules, (c) your failure to maintain a sufficient Balance in your LeafLink account to cover your obligations under these Payment Terms, (d) LeafLink’s affecting or attempt to affect your request for the cancellation, amendment or reversal of an Entry, or (e) LeafLink’s issuance of duplicate Entries.</span></p> <p><b><span>16. Additional Representations &amp; Warranties</span></b></p> <p><span>In addition to your representations, warranties and covenants contained in the Terms and Conditions of Use or Master Subscription Agreement, as applicable, you agree to the following representations and warranties specific to the Embedded Payment Services:</span></p> <p><span>(a) You represent and warrant that you have the right and authority to enter into these Payment Terms and that you are responsible for the management and permissioning of your organization’s payment processing.</span></p> <p><span>(b) You represent and Warrant that the bank account provided to LeafLink for use in connection with the Embedded Payment Services is the bank account associated with your cannabis business.</span></p> <p><b><span>17. Relationship to other terms and conditions.</span></b></p> <p><span>These Payment Terms are hereby incorporated into and made part of the Terms and Conditions of Use or Master Subscription Agreement, as applicable. To the extent the Payment Terms conflict with the Terms and Conditions of Use or Master Subscription Agreement, as applicable, these Payment Terms shall control with respect to the Embedded Payment Services and only to the extent of such conflict.</span></p> <p><b><span>18. Release.</span></b></p> <p><span>In addition to any related sections of the Terms and Conditions of Use or Master Subscription Agreement, as applicable, in the event of any Embedded Payment Service-related disputes, you release LeafLink (and our officers, directors, agents, subsidiaries, joint ventures and employees) from claims, demands and damages (actual and consequential) of every kind and nature, known and unknown, suspected and unsuspected, disclosed and undisclosed, arising out of or in any way connected with such disputes. You also agree that any disputes arising out of or relating to an ACH Entry or the Embedded Payment Services shall be resolved by the parties to the transaction and LeafLink is in no way responsible, nor will LeafLink be required to participate in any dispute resolution proceedings related to any such disputes.</span></p> <p><b><span>19. Definitions.</span></b></p> <p><span>(a) “<b>ACH Network</b>” means the funds transfer system (network) governed by the NACHA Operating Rules which provides for the clearing of electronic entries for participating Financial Institutions and Third-Party Senders.</span></p> <p><span>(b) “<b>Balance</b>” means the funds in your Enrolled Bank Account.</span></p> <p><span>(c) “<b>Enrolled Bank Account”&nbsp;</b>shall have the meaning set forth in Section 1(a).</span></p> <p><span>(d) “<b>Entry</b>” is an order or request for the transfer of money to the account of a Receiver or general ledger account of an RDFI (a “credit Entry”); or an order or request for the withdrawal of money from the account of a Receiver or general ledger account of an RDFI (a “debit Entry”). “Entry” may also refer to the transmission of notice or data that is not an order or request for the transfer or withdrawal of funds.</span></p> <p><span>(e) “<b>Fees</b>” are defined in Section 2.</span></p> <p><span>(f) “<b>Financial Institution</b>” means an Originating Depository Financial Institution that originates ACH Entries on behalf of Sellers.</span></p> <p><span>(g) “<b>NACHA Rules</b>” refers to the NACHA Operating Rules.</span></p> <p><span>(h) “<b>Originator</b>” means a person that has authorized a Financial Institution to transmit an Entry to a Receiver’s account at an RDFI.</span></p> <p><span>(i)&nbsp;<b>“RDFI”&nbsp;</b>or Receiving Depository Financial Institution means a Financial Institution qualified by NACHA to receive ACH Entries.</span></p> <p><span>(j) “<b>Receiver</b>” means a person that has authorized an Originator to initiate a credit Entry, debit Entry, or non-monetary Entry to the Receiver’s account at the RDFI.</span></p> <p><span>(k) “<b>Recovery Authorizations</b>” has the meaning set forth in Section shall have the meaning set forth in Section 11(a).</span></p> <p><span>(l) “<b>Third-Party Sender</b>” is an organization that is not an Originator that has authorized an Financial Institution to transmit, for its account or the account of another Third-Party Sender, a credit Entry, debit Entry, or non-monetary Entry to a Receiver’s account at an RDFI. LeafLink acts as a Third-Party Sender in conjunction with the Embedded Payment Services.</span></p> <p><b><span>20.&nbsp;Arbitration</span></b><span>. </span></p> <p><span>In the interest of resolving disputes between you and LeafLink in the most expedient and cost effective manner, you and LeafLink Payments agree that every dispute arising in connection with these Terms will be resolved by binding arbitration, to the fullest extent permitted under applicable law. This agreement to arbitrate disputes includes all claims arising out of or relating to any aspect of these Retailer Terms, whether based in contract, tort, statute, fraud, misrepresentation, or any other legal theory, and regardless of whether a claim arises during or after the termination of these Terms. YOU UNDERSTAND AND AGREE THAT, BY ENTERING INTO THESE TERMS, YOU AND LEAFLINK PAYMENTS ARE EACH WAIVING THE RIGHT TO A TRIAL BY JURY OR TO PARTICIPATE IN A CLASS ACTION, TO THE FULLEST EXTENT PERMITTED UNDER APPLICABLE LAW. Despite the provisions of this section, nothing in these Terms will be deemed to waive, preclude, or otherwise limit the right of either party to: (i) bring an individual action in small claims court or to seek payment for any Services provided by LeafLink; (ii) pursue an enforcement action through the applicable federal, state, or local agency if that action is available; (iii) seek injunctive relief in a court of law; or (iv) to file suit in a court of law to address an intellectual property infringement claim. To the fullest extent permitted under applicable law, any arbitration between you and LeafLink Payments will be settled under the Federal Arbitration Act, and governed by the Commercial Dispute Resolution Procedures and the Supplementary Procedures for Consumer Related Disputes (collectively, “AAA Rules”) of the American Arbitration Association (“AAA”). Any arbitration hearing will take place at a location to be agreed upon in New York, New York or through a non-appearance based telephone or online hearing. The arbitrator may award attorneys’ fees and expenses (including the cost of arbitration) to the Party which is required to receive payment from the other Party pursuant to the award resulting from this arbitration. </span></p>",
      "termsDescription": "We’ve updated our Terms and Conditions to cover our existing {payments} & {logistics} offerings. Terms will apply based on services used."
    },
    "linkABankCta": {
      "buyerHeading1": "Pay via LeafLink Direct Pay",
      "dismissButton": "Skip linking your bank",
      "initiationError": "There was an error with your request. An onboarding specialist will reach out soon.",
      "linkYourBankSecurelyWith": "Link your bank securely with",
      "sellerHeading1": "Get Paid via LeafLink Direct Pay",
      "submitButton": "Link your bank"
    },
    "self": "Terms & Conditions",
    "survey": {
      "body1": "If you have a moment, please let us know why you are not linking your bank.",
      "checkboxLabel1": "Not the right person ",
      "checkboxLabel2": "We don't have a bank account",
      "checkboxLabel3": "I want to do this at another time",
      "checkboxLabel4": "Other (please explain below)",
      "emailError": "Please enter a valid email address",
      "emailHint": "Send a referral link to sign up for LeafLink Payments. Seperate multiple addresses by commas.",
      "enterEmail": "enter an email address"
    }
  },
  "trustedSeller": {
    "alerts": {
      "regainRequirement": "Regain this requirement by {date} in order to maintain your status."
    },
    "current": "Current",
    "errors": {
      "generalServerError": "There was a problem retrieving Certified Seller report data. Please try again or contact support.",
      "incompletePrereqError": "You must meet all {prereq} Criteria to be an {tier}.",
      "noOrdersFound": "No orders found."
    },
    "factors": {
      "activeLicense": {
        "description": "Make sure that your current, valid cannabis sales license is attached to this account.",
        "title": "License verification"
      },
      "avgOrganicOrdersResponseTime": {
        "description": "Buyers love fast service. Make sure to review newly received orders every day.",
        "stat": "Average order review time {value}",
        "title": "Average Order Review Time"
      },
      "brandHasImageAndDescription": {
        "description": "Add a Brand Logo and Description to your menu, to improve your brand awareness with our network of retailers.",
        "title": "Logo and description"
      },
      "inventoryUpdated": {
        "description": "Reconcile inventory levels frequently, to keep product availability accurate for buyers.",
        "stat": "{value} inventory/menu updates",
        "title": "Product Assortment & Availability Updates"
      },
      "orderAcceptanceRate": {
        "description": "Work with buyers to ensure that as few orders as possible are rejected. Helps build buyer confidence that orders will be fulfilled.",
        "stat": "{value} order acceptance rate",
        "title": "Order Acceptance Rate"
      },
      "organicOrdersWithShipDate": {
        "description": "Add shipment dates to your orders to help buyers understand when to expect delivery, and plan for receiving.",
        "stat": "{value} of orders have ship dates",
        "title": "Order Ship Dates"
      },
      "receivedOrganicOrders": {
        "description": "A track record of orders gives buyers confidence in your ability to deliver.",
        "stat": "{value} buyer generated orders",
        "title": "Buyer Generated Orders"
      }
    },
    "sellerStatus": {
      "description": "Track your progress towards earning trust-building LeafLink Certified Seller badges.",
      "learnMore": "Learn More",
      "statUpdates": "Statistics updated daily at 3am.",
      "title": "Certified Seller Status Achievement"
    },
    "target": "Target",
    "tiers": {
      "eliteSeller": {
        "description": "The best-of-the-best on LeafLink. Elite sellers provide exceptional service to buyers. Must also meet Power Seller Criteria.",
        "title": "Elite Seller"
      },
      "powerSeller": {
        "description": "Set the standard for selling on LeafLink. Power Sellers have complete accounts, and provide reliable service to buyers.",
        "title": "Power Seller"
      }
    },
    "units": {
      "hour": "hrs"
    },
    "values": {
      "active": "Active",
      "expired": "Expired"
    },
    "widget": {
      "no_status_heading": "Certified Seller Requirements",
      "status_heading": "You're a LeafLink {status}"
    }
  },
  "unitConversionModal": {
    "conversionExplanation": "Please set a custom conversion value below. A value can be determined with this equation:",
    "conversionFormula": "LeafLink Unit = Metrc Unit / Conversion Value",
    "conversionSubText": "Metrc Unit / Conversion Value",
    "conversionTotalPlaceholder": "Enter a conversion value to calculate total",
    "leaflinkUnit": "LeafLink Unit"
  },
  "validation": {
    "available": "Cannot be more than {available}",
    "betweenVal": "Must be between {value}",
    "charactersRemaining": "{value} characters remaining",
    "duplicateFile": "Duplicate file",
    "einFormat": "Enter only numbers and dashes",
    "email": "E-mail must be valid",
    "exceededVal": "Must not exceed {value}",
    "fieldErrors": "Please fix field errors",
    "fractionalUnits": "Must be whole units",
    "higherVal": "Must be higher than {value}",
    "invalidDateRange": "Invalid Date Range",
    "invalidNumber": "Must be a valid number",
    "maxVal": "Must be at most {value}",
    "minVal": "Must be at least {value}",
    "notValidTime": "Please enter a time in a valid HH:MM format",
    "notValidValue": "Must not be {value}",
    "onlyNumAvailable": "Only {num} available",
    "openNotBeforeClose": "Open time must be before close time",
    "partialCases": "Please order down to a full case pack",
    "phone": "10 digits required",
    "phoneFormats": "Please enter a valid phone number. Examples: 123-456-7890, 1234567890, (123) 456-7890",
    "positiveNumber": "Must be greater than 0",
    "qtyUnavailable": "QTY unavailable",
    "required": "Required",
    "requiredAPIKey": "Please enter an API key",
    "requiredForLicenseType": "Required for license type",
    "selectionRequired": "Selection required",
    "valueRequired": "Value is required",
    "wholeNumber": "Must be a Whole Number"
  }
}
